{
  "contentAutomation": {
    "seoTitle": "SEO score",
    "seoTarget": "SEO target: at least 7.5/10 with no regression. Quality and factual checks still apply.",
    "seoMissing": "Not SEO-assessed yet.",
    "seoStale": "The text has changed since assessment. The previous SEO score does not apply to this version.",
    "seoHint": "Automatic publishing requires at least 7.5/10 with no regression. This assesses copy and metadata, not rankings, search volume or technical SEO.",
    "seoParts": { "SearchIntent": "Keywords and search intent", "Metadata": "Meta title and description", "Coverage": "Product information coverage", "Structure": "Structure and readability" },
    "approve": "Approve and publish",
    "approveHint": "Approving accepts the displayed proposal and the findings above. The description and SEO will be published to Shopify and saved in Smibo. Your approval is logged and the original is retained.",
    "manuallyApproved": "Manually approved on {date}. The approval and original findings are retained in history.",
    "recheck": "Check proposal again",
    "title": "Content and content score",
    "intro": "Optimise existing Shopify products, keep the originals and publish changes that pass the checks.",
    "policy": "Descriptions and SEO update automatically. Existing statements are treated as approved and may be reworded without stronger promises. New or strengthened risk claims require review. Products are selected from existing Shopify listings with known SKUs and copy. Visibility stays unchanged.",
    "count": "Number of products", "start": "Optimise and publish", "stop": "Stop remaining products",
    "history": "Show history and results", "hide": "Hide history", "running": "Running", "ready": "Ready",
    "summary": "Latest batch: {total} products · {published} published · {exceptions} need attention",
    "scoreHint": "The score is an AI assessment of the copy, not a promise of rankings or sales. Fact checking means consistency with the source, not independent verification.",
    "product": "Product", "score": "Content score", "status": "Status", "details": "View changes",
    "before": "Before", "after": "Proposal / after", "claims": "Claims and sources",
    "restore": "Restore originals in Smibo and Shopify", "reconcile": "Check publication result again",
    "restoreHint": "Originals are stored for both Smibo and Shopify. Restoration stops if someone has edited the copy since publication.",
    "parts": {"BuyerHelp":"Buying guidance / 30", "Accuracy":"Accuracy / 25", "Readability":"Readability / 20", "SearchRelevance":"Search relevance / 15", "Specificity":"Product-specific value / 10"},
    "states": {"Queued":"Queued", "Evaluating":"Writing and checking", "Rechecking":"Checking again", "Publishing":"Publishing", "Published":"Published", "NeedsReview":"Needs review", "Conflict":"Source changed", "Failed":"Failed", "NeedsReconciliation":"Result needs checking", "RestoreQueued":"Restore queued", "Restoring":"Restoring", "Restored":"Original restored", "Cancelled":"Stopped"}
  },
  "nav": {
    "breadcrumb": "Breadcrumb",
    "opsSection": "Super admin",
    "jobDashboard": "Job dashboard",
    "openMenu": "Open menu",
    "accountMenu": "Account menu",
    "signOut": "Sign out",
    "lightTheme": "Light theme",
    "darkTheme": "Dark theme",
    "dashboard": "Overview",
    "packing": "Packing list",
    "orders": "Orders",
    "orderDetail": "Order",
    "returns": "Returns",
    "customers": "Customers",
    "subscriptions": "Subscriptions",
    "subscriptionDetail": "Subscription",
    "subscriptionPlans": "Subscriptions for sale",
    "purchasing": "Purchasing",
    "purchaseOrders": "Purchase orders",
    "purchaseOrderDetail": "Purchase order",
    "products": "Products",
    "categories": "Categories",
    "brands": "Brands",
    "variantTypes": "Variant types",
    "stockMovements": "Stock journal",
    "suppliers": "Suppliers",
    "supplierDetail": "Supplier",
    "messages": "Messages",
    "messageTemplates": "Templates",
    "shippingRules": "Shipping rules",
    "reports": "Reports",
    "channels": "Channels",
    "migration": "Data migration",
    "catalogue": "Supplier catalogue",
    "campaigns": "Mail suggestions",
    "members": "Users",
    "settings": "Settings",
    "translations": "Your own words",
    "carriers": "Carrier accounts",
    "platform": "Operations",
    "integrations": "Connections",
    "group": {
      "sales": "Sales",
      "subscriptions": "Subscriptions",
      "stock": "Stock",
      "shipping": "Shipping",
      "setup": "Setup"
    }
  },
  "common": {
    "cancel": "Cancel",
    "nevermind": "Never mind",
    "save": "Save",
    "saveChanges": "Save changes",
    "saveFailed": "Could not save",
    "create": "Create",
    "confirm": "Confirm",
    "delete": "Delete",
    "edit": "Edit",
    "hide": "Hide",
    "search": "Search",
    "loading": "Loading…",
    "unexpectedError": "Something went wrong.",
    "add": "Add",
    "remove": "Remove",
    "optional": "optional",
    "optionalField": "Optional",
    "none": "None",
    "close": "Close",
    "allStatuses": "All statuses",
    "actionFailed": "That did not work",
    "units": "{count} pcs",
    "days": "{count} days",
    "errors": {
      "tooManyRequests": "Too many attempts right now. Wait a moment and try again."
    }
  },
  "customers": {
    "title": "Customers",
    "subtitle": "Who has bought what. Created automatically the first time an order arrives.",
    "searchPlaceholder": "Name, email, company or phone",
    "blockedOnly": "Blocked only",
    "empty": "No customers found.",
    "loadFailed": "Could not load customers.",
    "loadOneFailed": "Could not load the customer",
    "saved": "Customer saved",
    "saveFailed": "Could not save",
    "columns": {
      "customer": "Customer",
      "phone": "Phone",
      "orders": "Orders",
      "spent": "Spent",
      "latest": "Latest"
    },
    "blocked": "Blocked",
    "blockedBanner": "This customer is blocked.",
    "acceptsMarketing": "Has agreed to marketing",
    "blockCustomer": "Block this customer",
    "stats": {
      "orders": "orders",
      "spent": "spent",
      "average": "average",
      "returns": "returns"
    },
    "customerSince": "Customer since {date}",
    "internalNote": "Internal note:",
    "sections": {
      "orders": "Orders",
      "subscriptions": "Subscriptions"
    },
    "noOrders": "No orders yet.",
    "lineCount": "{count} lines",
    "nextRun": "next {date}",
    "fields": {
      "name": "Name",
      "company": "Company",
      "phone": "Phone",
      "vatNumber": "VAT number",
      "internalNote": "Internal note",
      "blockedReason": "Reason for blocking"
    },
    "merge": {
      "action": "Merge…",
      "title": "Merge customer",
      "intro": "{name} ({email}) will be filed under the customer you choose. The order history moves with them, and future orders from {email} land in the same place.",
      "explainer": "The address stays as a redirection so it cannot become a new duplicate. The internal note and any block come across; permission to send marketing does not.",
      "searching": "Looking for duplicates…",
      "candidates": "Looks like the same person",
      "orSearch": "Or search for the customer",
      "searchPlaceholder": "Name, email or phone",
      "choose": "Choose a customer",
      "confirm": "Merge into {name}",
      "done": "Merged into {name}",
      "orderNoun": "{count} order | {count} orders",
      "subscriptionNoun": "{count} subscription | {count} subscriptions",
      "movedBoth": "{orders} and {subscriptions} moved across.",
      "movedOrders": "{count} order moved across. | {count} orders moved across.",
      "movedSubscriptions": "{count} subscription moved across. | {count} subscriptions moved across.",
      "movedNothing": "There was nothing to move.",
      "undoneBoth": "{orders} and {subscriptions} moved back.",
      "undoneOrders": "{count} order moved back. | {count} orders moved back.",
      "undoneSubscriptions": "{count} subscription moved back. | {count} subscriptions moved back.",
      "failed": "Could not merge",
      "orderCount": "{count} orders",
      "reasons": {
        "phone": "Same phone number",
        "vatNumber": "Same VAT number",
        "company": "Same company name",
        "name": "Same name"
      },
      "mergedBannerTitle": "This address has been merged.",
      "mergedBanner": "Orders and future purchases from {email} now belong to {name}.",
      "undo": "Undo the merge",
      "undone": "The merge has been undone",
      "undoFailed": "Could not undo",
      "errors": {
        "intoSelf": "A customer cannot be merged into itself.",
        "targetNotFound": "The customer you chose does not exist.",
        "alreadyMerged": "This customer has already been merged into another.",
        "targetIsRedirect": "The customer you chose has itself been merged away. Choose the one that stayed.",
        "undoNotMerged": "This customer has not been merged.",
        "undoNoRecord": "There is no record of this merge, so it cannot be undone automatically.",
        "undoSurvivorMerged": "The customer that stayed has since been merged itself. Undo the later merge first.",
        "undoSurvivorMissing": "The customer that stayed does not exist."
      },
      "notes": {
        "blockCarried": "Carried across in a merge.",
        "blockSurvivedUndo": "[This block came from a merge that has since been undone]",
        "mergedFrom": "Carried across in a merge."
      }
    },
    "tabs": {
      "products": "Products",
      "categories": "Categories",
      "imports": "Imports"
    },
    "status": {
      "New": "New",
      "Published": "In the shop",
      "Rejected": "Not sold"
    },
    "errors": {
      "notFound": "The customer does not exist.",
      "blockedReasonRequired": "Give a reason when blocking a customer.",
      "noVatNumber": "This customer has no VAT number to look up."
    },
    "vat": {
      "verify": "Check with VIES",
      "verifyFailed": "The lookup failed",
      "checkedAt": "Checked {date}",
      "receipt": "Receipt {number}",
      "noReceipt": "No receipt — fill in the shop's own VAT number under VAT to get one.",
      "stale": "This lookup is more than a day old.",
      "status": {
        "Unchecked": "Not checked",
        "Valid": "Registered",
        "Invalid": "Not registered",
        "Unavailable": "The register did not answer"
      },
      "lookUp": "Look up",
      "registeredAddress": "Registered address"
    }
  },
  "settings": {
    "errors": {
      "senderEmailInvalid": "That does not look like an email address."
    },
    "vat": {
      "title": "VAT",
      "intro": "Used for the amounts smibo works out itself — subscription charges and manually entered lines. Amounts that came from a checkout keep the rate that checkout charged.",
      "loadFailed": "The VAT configuration could not be loaded.",
      "saved": "VAT configuration saved",
      "homeCountry": "Shop's country",
      "homeCountryHelp": "Decides which sales are domestic and which are exports. Blank is read as Denmark.",
      "defaultRate": "Shop's own rate",
      "defaultRateHelp": "As a fraction: 0.25 for 25 %. Blank is read as the Danish standard rate.",
      "ossTitle": "Distance selling rates (OSS)",
      "ossHelp": "Only needed once the shop is registered for OSS. A country that is not listed is charged the shop's own rate — right until you register, and wrong afterwards.",
      "addCountry": "Add country",
      "save": "Save VAT",
      "ownVatNumber": "The shop's own VAT number",
      "ownVatNumberHelp": "Sent along when you look up a customer's VAT number. VIES issues a receipt only when it knows who is asking, and the receipt is what turns a lookup into evidence.",
      "ownVatNumberPlaceholder": "GB123456789"
    },
    "language": {
      "title": "Language",
      "intro": "The code is English; the screens speak whatever you choose. The workspace language also applies to the pages your customers see — sign-up and the subscription portal — where nobody is signed in.",
      "workspace": "Workspace language",
      "mine": "My language",
      "followWorkspace": "Follow the workspace",
      "saved": "Language saved"
    },
    "openJobDashboard": "Open job dashboard",
    "twoFactorTitle": "Emailed code at sign-in",
    "twoFactorBody": "With this on, we email you a code whenever you sign in on a new computer. You can ask us not to ask again on the one you are using.",
    "twoFactorOn": "The emailed code is on",
    "twoFactorOff": "The emailed code is off",
    "twoFactorFailed": "The setting could not be saved."
  },
  "vat": {
    "errors": {
      "rateMustBeFraction": "Enter the rate as a fraction: 0.25 for 25 %.",
      "countryCodeInvalid": "The country code must be two letters, for example DK.",
      "countryRateInvalid": "The rate must be a fraction between 0 and 1."
    }
  },
  "signUp": {
    "notFoundTitle": "This page does not exist",
    "notFoundBody": "The link is either wrong or no longer active. Contact the shop if you think this is a mistake.",
    "loadFailed": "The page could not be loaded. Try again shortly.",
    "everyMonth": "Delivered every month",
    "everyNMonths": "Delivered every {count} months",
    "delivery": "Delivery",
    "perDelivery": "Per delivery",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "postalCode": "Postcode",
    "city": "Town",
    "note": "Message to the shop",
    "beforeSubmit": "We will send you an email to confirm — nothing is created before then, and no money is taken. The first delivery goes out no earlier than {date}, and you can cancel at any time.",
    "submit": "Sign up",
    "checkInboxTitle": "Check your inbox",
    "checkInboxBody": "We have sent an email to {email}. Click the link in it and you are signed up.",
    "nothingCreated": "Nothing has been created yet, and no money has been taken. We only create the subscription once you have confirmed the address is yours.",
    "spamHint": "If you cannot find the email, check your spam filter. The link works for seven days.",
    "errors": {
      "emailInvalid": "Enter a valid email address.",
      "nameRequired": "Enter a name.",
      "addressRequired": "Enter an address and postcode.",
      "planUnavailable": "This subscription cannot be taken out right now.",
      "cannotComplete": "The sign-up could not be completed. Get in touch and we will help.",
      "failed": "The sign-up could not be completed. Try again shortly."
    },
    "notes": {
      "signedUpOnline": "Signed up through the website."
    }
  },
  "returns": {
    "title": "Returns",
    "subtitle": "Goods on their way back, what arrived, and what the customer got back.",
    "empty": "No returns yet.",
    "loadFailed": "Could not load returns.",
    "searchPlaceholder": "Return no., order no. or email",
    "orderPrefix": "order",
    "reasonColumn": "Reason",
    "amountColumn": "Amount",
    "announcedQuantity": "{count} announced at",
    "restockable": "Can be sold again",
    "backInStock": "{count} back in stock",
    "shrinkageNote": "The difference between received and \"can be sold again\" is posted as shrinkage, so the loss is visible in the stock journal.",
    "refundAmount": "Amount to refund",
    "goodsValue": "The goods are {amount}.",
    "postReceived": "Post as received",
    "saveAmount": "Save amount",
    "refund": "Refund",
    "refundWithAmount": "Refund {amount}",
    "received": "The goods have been posted in",
    "amountSaved": "Amount saved",
    "refunded": "The amount has been refunded",
    "customerColumn": "Customer",
    "announcedColumn": "Announced",
    "failed": "Failed",
    "receivedLabel": "Received",
    "receivedCount": "{count} received",
    "refundSection": "Refund",
    "refundConfirm": "{amount} will be paid back to the customer. This cannot be undone from here.",
    "captured": "The order captured {amount}.",
    "status": {
      "Announced": "Announced",
      "Received": "Received",
      "Completed": "Refunded",
      "Cancelled": "Cancelled"
    },
    "reason": {
      "Regret": "Changed their mind",
      "WrongSize": "Wrong size",
      "Defective": "Faulty",
      "WrongItemSent": "Wrong item sent",
      "DamagedInTransit": "Damaged in transit",
      "NotDelivered": "Never arrived",
      "Other": "Other"
    },
    "numberColumn": "Return"
  },
  "stock": {
    "title": "Stock journal",
    "subtitle": "Every change to the physical stock, with its reason and the balance afterwards.",
    "empty": "No movements yet.",
    "allReasons": "All reasons",
    "loadFailed": "Could not load the stock journal.",
    "searchPlaceholder": "SKU or reference",
    "timeColumn": "Time",
    "productColumn": "Product",
    "balanceColumn": "Balance",
    "reasonColumn": "Reason",
    "changeColumn": "Change",
    "causeColumn": "Caused by",
    "reason": {
      "Dispatch": "Dispatched",
      "GoodsReceipt": "Goods receipt",
      "Adjustment": "Adjustment",
      "Return": "Return",
      "Shrinkage": "Shrinkage"
    }
  },
  "messages": {
    "title": "Messages",
    "subtitle": "Everything the system decided to send — including what did not go out.",
    "loadFailed": "Could not load the messages.",
    "dispatchNow": "Send now",
    "dispatched": "{count} message sent | {count} messages sent",
    "dispatchFailed": "Sending failed",
    "requeued": "Back in the queue",
    "requeue": "Put back in the queue",
    "retryFailed": "Could not send again",
    "searchPlaceholder": "Recipient, subject or reference",
    "empty": "No messages yet.",
    "noSenderTitle": "No mail provider is connected.",
    "noSenderBody": "Messages are marked as sent and written to the log, but never reach the recipient.",
    "noSenderAddress": "No sender address has been given, so every message is suppressed.",
    "toSettings": "Go to settings",
    "countSent": "{count} sent",
    "countPending": "{count} pending",
    "countRetrying": "{count} retrying",
    "countFailed": "{count} failed",
    "countSuppressed": "{count} not sent",
    "attempts": "{count} attempts",
    "viewMessage": "View the message",
    "sendAgain": "Send again",
    "toRecipient": "To {email}",
    "columns": {
      "recipient": "Recipient",
      "message": "Message"
    },
    "status": {
      "Pending": "Pending",
      "Sent": "Sent",
      "Retrying": "Retrying",
      "Failed": "Failed",
      "Suppressed": "Not sent"
    }
  },
  "messageTemplates": {
    "title": "Message settings",
    "subtitle": "Sender, support and the words customers read. Every template has a default — you only change the ones you want in your own words.",
    "back": "Back to messages",
    "loadFailed": "Could not load the settings.",
    "settingsSaved": "The settings are saved",
    "saveSettings": "Save settings",
    "templateSaved": "The template is saved",
    "previewFailed": "Could not render the preview",
    "preview": "Preview",
    "senderMissing": "Without a sender address every message is suppressed. Fill in the field below.",
    "senderSection": "Sender and contact",
    "senderNamePlaceholder": "e.g. Happy Horse",
    "currencyHint": "What you buy, sell and report in. Cost prices are stored in this currency, and are only pushed to a shop using the same one.",
    "whenSection": "When to write",
    "noticeDaysHint": "0 switches the notice off.",
    "backorderDaysHint": "Shorter delays are not worth worrying the customer with.",
    "notificationsEnabled": "Send messages to customers",
    "panelsSection": "Panels on the overview",
    "panelsHint": "Choose what the front page shows. The order is the order you tick them in. None chosen gives the default set.",
    "customised": "Customised",
    "switchedOff": "Switched off",
    "unknownTag": "Unknown: {names}",
    "unknownVariables": "Unknown variables: {names}",
    "resetTitle": "Reset template",
    "resetBody": "\"{name}\" goes back to the default wording. Your own text is deleted.",
    "reset": "Reset",
    "resetToDefault": "Reset to the default wording",
    "resetDone": "The default wording is back",
    "resetFailed": "Could not reset",
    "bodyLabel": "Text",
    "availableVariables": "Available variables",
    "variablesHint": "Click to insert. Unknown variables render as nothing.",
    "sendThis": "Send this message",
    "fields": {
      "senderName": "Sender name",
      "senderEmail": "Sender address",
      "replyTo": "Reply-to",
      "supportEmail": "Support email",
      "supportPhone": "Support phone",
      "shopUrl": "The shop's address",
      "currency": "Currency",
      "noticeDays": "Notice before a subscription delivery (days)",
      "backorderDays": "Mention a backorder from (days)"
    },
    "template": {
      "order": {
        "shipped": {
          "name": "Order shipped",
          "description": "Sent when an order is packed and dispatched."
        },
        "ready-for-pickup": {
          "name": "Ready for pickup",
          "description": "Sent when a click and collect order is packed and waiting in the shop."
        },
        "backordered": {
          "name": "Item backordered",
          "description": "Sent when one or more items on an order are waiting on the supplier."
        },
        "cancelled": {
          "name": "Order cancelled",
          "description": "Sent when an order is cancelled."
        }
      },
      "subscription": {
        "delivered": {
          "name": "Subscription shipped",
          "description": "Sent when a subscription has been charged and the parcel is on its way."
        },
        "payment-failed": {
          "name": "Payment failed",
          "description": "Sent when a subscription could not be charged. Asks the customer to renew the card."
        },
        "card-expiring": {
          "name": "Card expiring soon",
          "description": "Sent before a payment card expires, so the charge does not fail."
        },
        "confirm-sign-up": {
          "name": "Confirm sign-up",
          "description": "Sent when somebody fills in the sign-up form. Nothing is created until the link is clicked."
        },
        "signed-up": {
          "name": "Sign-up received",
          "description": "Sent when somebody subscribes on the website. The subscription is not active yet."
        },
        "cancelled": {
          "name": "Subscription ended",
          "description": "Sent when a subscription ends."
        }
      },
      "purchasing": {
        "order-to-supplier": {
          "name": "Order to the supplier",
          "description": "Sent to the supplier when a purchase order is marked as ordered."
        }
      },
      "account": {
        "welcome": {
          "name": "Welcome",
          "description": "Sent to the owner shortly after a workspace is created. Carries the link that confirms the email address."
        },
        "confirm-email": {
          "name": "Confirm email address",
          "description": "Sent when somebody asks for the confirmation link again. Cannot be switched off — it is the way into the account."
        },
        "password-reset": {
          "name": "Reset password",
          "description": "Sent when somebody has forgotten their password. Cannot be switched off — it is the way into the account."
        },
        "invitation": {
          "name": "Workspace invitation",
          "description": "Sent when an administrator creates a member. Carries the link where they choose their password. Cannot be switched off — it is the way into the account."
        },
        "two-factor-code": {
          "name": "Sign-in code",
          "description": "Sent when somebody with the code turned on signs in. Dispatched immediately rather than waiting for the message run, and cannot be switched off."
        }
      }
    }
  },
  "channels": {
    "title": "Channels",
    "subtitle": "Web shops that send orders to smibo. Access tokens are stored encrypted and never shown again.",
    "loadFailed": "Could not load the connections.",
    "empty": "There are no channels yet. For now, orders can only come from subscriptions.",
    "connect": "Connect a shop",
    "connectAction": "Connect",
    "editConnection": "Edit connection",
    "saved": "The connection is saved",
    "dandomainMigrationOnly": "Dandomain (migration only)",
    "noShopAddress": "No shop address",
    "lastSynced": "last synced {time}",
    "readUpTo": "read up to {time}",
    "test": "Test",
    "testWorks": "The connection works",
    "testFailed": "The connection failed",
    "fetchOrders": "Fetch orders",
    "syncDone": "Sync finished",
    "syncSummary": "{seen} seen · {created} new · {updated} updated · {errors} errors",
    "runSummary": "{seen} seen · {created} new · {updated} updated",
    "pushCostPrices": "Push cost prices",
    "retryRejected": "Also retry the ones the shop turned down",
    "pushed": "{count} pushed",
    "pushSkipped": "{count} do not exist in the shop",
    "pushFailedCount": "{count} failed — retried tonight",
    "allAlreadyPushed": "Every cost price has already been pushed",
    "costPricesPushed": "Cost prices pushed",
    "pushFailed": "Could not push the cost prices",
    "readiness": {
      "button": "Order readiness",
      "title": "Shopify order readiness",
      "loading": "Checking the complete order path …",
      "ready": "The platform is ready to receive Shopify orders automatically.",
      "notReady": "Manual order fetching may be testable, but automatic delivery still has one or more missing steps.",
      "provision": "Set up order webhooks",
      "provisioned": "Shopify webhooks are configured",
      "provisionConfirmTitle": "Set up order webhooks in Shopify?",
      "provisionConfirmMessage": "The platform creates or updates webhooks for new, updated, cancelled and paid orders, refunds and order transactions. Subscriptions owned by other apps are left untouched.",
      "states": {
        "ready": "Ready",
        "warning": "Note",
        "blocked": "Missing"
      }
    },
    "storefront": {
      "button": "Collections and menu",
      "title": "Shopify storefront structure",
      "loading": "Building the preview …",
      "intro": "Smibo turns the active Dandomain structure into automated Shopify collections and a fixed, clear main menu with at most three levels.",
      "collections": "collections in total",
      "catalog": "catalog categories",
      "brands": "brands",
      "special": "special collections",
      "menuHeading": "Fixed main menu",
      "submenuCount": "{count} subitems",
      "rerunHint": "The sync can be run again. Smibo finds collections by category ID and only updates them when the plan has changed.",
      "sync": "Sync to Shopify",
      "confirmTitle": "Replace Shopify's main menu?",
      "confirmMessage": "This creates or updates {count} collections, publishes them to Online Store, and replaces Shopify's current main menu with the structure shown.",
      "done": "The storefront structure is synced",
      "doneDetail": "{created} created · {updated} updated · {reused} reused · {menu} menu items"
    },
    "productMigration": {
      "button": "Products to Shopify",
      "title": "Products for Shopify",
      "loading": "Reviewing the product catalogue …",
      "intro": "Smibo suggests a small, representative pilot from active in-stock products. Two places are reserved for the largest eligible variant families so the variant structure is properly tested.",
      "relevant": "active with stock, sales or available to order",
      "ready": "ready to transfer",
      "waveOne": "ready and in stock",
      "needsWork": "need corrections",
      "history": "Sales figures cover the imported order history from {from} to {to}.",
      "pilotHeading": "Suggested pilot",
      "pilotHint": "You can deselect products. Any change to the selection always requires a new dry run.",
      "selection": "{products} products · {variants} active variants",
      "variantCount": "{count} variants",
      "stock": "{count} in stock",
      "sold": "{count} sold",
      "publishSafety": "The first run writes nothing. The final run activates the products and publishes them directly to Online Store. Stock on existing Shopify variants is not overwritten.",
      "dryRun": "Test without writing",
      "publishActive": "Publish active products",
      "confirmTitle": "Publish the product pilot in Shopify?",
      "confirmMessage": "{products} products with {variants} active variants in total will be created or updated, activated, and published directly to Online Store. Stock on existing Shopify variants is not overwritten.",
      "dryRunDone": "The pilot has been tested",
      "liveDone": "The product pilot was sent to Shopify",
      "resultSummary": "{succeeded} succeeded · {failed} failed",
      "dryRunResult": "Dry-run result",
      "liveResult": "Shopify result",
      "variantResult": "{created} new variants · {updated} updated · {images} images",
      "bulkHeading": "Bulk migration",
      "bulkHint": "Waves run in the background and resume after a restart. Products are activated and published directly to Online Store.",
      "waveOneTitle": "Wave 1 · in-stock products",
      "waveOneDetail": "{count} prepared products with available stock are migrated first.",
      "waveTwoTitle": "Wave 2 · previously sold products",
      "waveTwoDetail": "{count} prepared sold-out products with sales history can be migrated afterwards.",
      "startWaveOne": "Start wave 1",
      "startWaveTwo": "Start wave 2",
      "waveThreeTitle": "Wave 3 · available to order",
      "waveThreeDetail": "{count} prepared products without stock or sales history can be purchased according to Dandomain.",
      "startWaveThree": "Start wave 3",
      "startAll": "Migrate all prepared products",
      "startWave": "Start migration",
      "bulkConfirmTitle": "Start the Shopify bulk migration?",
      "bulkConfirmMessage": "{count} products will be created or updated, activated and published to Online Store. The job can resume after a restart, and failures can be retried separately.",
      "bulkQueued": "Bulk migration started",
      "bulkQueuedDetail": "{count} products are now in the resumable queue.",
      "jobCounts": "{done} of {total} processed · {ok} succeeded · {errors} errors",
      "currentProduct": "Working on",
      "stopJob": "Stop after this product",
      "retryFailures": "Retry failures",
      "showErrors": "Show errors ({count})",
      "waves": {
        "InStock": "Wave 1 · in-stock products",
        "SoldOutWithSales": "Wave 2 · previously sold products",
        "AvailableToOrder": "Wave 3 · available to order",
        "AllReady": "All prepared products",
        "RetryFailures": "Retry failed products"
      },
      "jobStatus": {
        "Queued": "Queued",
        "Running": "Running",
        "Completed": "Completed",
        "CompletedWithErrors": "Completed with errors",
        "Cancelled": "Stopped",
        "Failed": "Failed"
      },
      "actions": {
        "Created": "Create",
        "Updated": "Update",
        "Failed": "Failed"
      }
    },
    "webhookUrl": "Webhook address for the shop",
    "webhookCopied": "Webhook address copied",
    "copyWebhook": "Copy the webhook address",
    "secretStored": "Secret stored",
    "secretMissing": "Secret missing",
    "needsFixing": "(needs fixing)",
    "platform": "Platform",
    "dandomain": {
      "username": "Username",
      "usernamePlaceholder": "shop{'@'}example.com",
      "usernameHint": "The email address of the Dandomain user the API access hangs on. Not a shop address — the endpoint is the same for everybody.",
      "imageBase": "Image URL",
      "imageBasePlaceholder": "https://shop12598.sfstatic.io/upload_dir/shop/",
      "imageBaseHint": "Dandomain sends only a picture's file name — the host belongs to the shop. Without this the migration imports no product pictures. Find it by right-clicking a picture in the shop and copying the image address, then keep everything up to and including the last slash.",
      "password": "Password",
      "note": "Dandomain is migration only. There are no webhooks and no ongoing order sync from here — products, customers and order history come in under Data migration.",
      "openMigration": "Data migration"
    },
    "shopAddress": "Shop address",
    "shopAddressPlaceholder": "yourshop.myshopify.com",
    "shopAddressHint": "Use the permanent address, not your own domain — that is the one webhooks come from.",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "clientCredentialsHint": "From the app in Shopify's Dev Dashboard under Settings → Credentials. smibo swaps them for a daily access token itself, and the secret also verifies the app's webhooks. The app must be installed in the store.",
    "accessToken": "Access token (older app with a permanent token)",
    "webhookSecret": "Webhook secret",
    "webhookSecretHint": "Found in Shopify under Notifications → Webhooks.",
    "storedReplace": "— stored, fill in only to replace",
    "fetchOrdersFrom": "Fetch orders from",
    "fetchOrdersFromHint": "Orders before this date are not fetched. Leave blank for the last seven days.",
    "runStatus": {
      "Running": "Running",
      "Completed": "Completed",
      "CompletedWithErrors": "Completed with errors",
      "Failed": "Failed",
      "Abandoned": "Abandoned"
    }
  },
  "migration": {
    "title": "Data migration from Dandomain",
    "subtitle": "Pulls categories, products, customers and order history into smibo. Nothing is ever written back to Dandomain — the shop can keep trading meanwhile.",
    "loadFailed": "Could not load the migrations.",
    "noConnection": "Create a Dandomain connection under {channels} first, with the username and password for the shop's API.",
    "connection": "Connection",
    "chooseConnection": "Choose a connection",
    "ordersFrom": "Orders from",
    "ordersTo": "Orders to",
    "everything": "Everything",
    "deltaOption": "Catch-up (only what is new since last time)",
    "notConfigured": "{name} has no username and password for the Dandomain API. Fill them in under {channels} before you start.",
    "rerunHint": "Run it as many times as you like. Each run updates what has already been pulled rather than creating it again — so an interrupted run can simply be started over.",
    "start": "Start migration",
    "started": "Migration started",
    "startedDetail": "It keeps running in the background — you can safely leave this page.",
    "startFailed": "Could not start the migration.",
    "stop": "Stop",
    "stopping": "Stopping",
    "stoppingDetail": "The migration finishes the record it is on. Nothing already pulled is lost.",
    "stopFailed": "Could not stop the migration.",
    "refresh": "Refresh",
    "latestRun": "Latest run",
    "ordersThrough": "Orders have been pulled through {date}. A new run continues from there.",
    "justStarted": "The run has only just started.",
    "andMore": "… and {count} more.",
    "earlierRuns": "Earlier runs",
    "noEarlierRuns": "No earlier runs.",
    "delta": "Catch-up",
    "full": "Full",
    "errors": {
      "noCredentials": "The connection has no username and password for Dandomain's API.",
      "abandoned": "The run stopped unexpectedly — the server restarted while it was working. Start a new one; it resumes from the date the orders reached."
    },
    "live": {
      "working": "Working on {phase}",
      "starting": "Starting up …",
      "seen": "{count} found",
      "heartbeat": "sign of life {when}",
      "secondsAgo": "{count} s ago",
      "minutesAgo": "{count} min ago",
      "orderWindow": "Orders {from} to {to}",
      "stalled": "No sign of life for over a quarter of an hour. The run has probably died — a new one can be started, and it resumes from the date the orders reached."
    },
    "probe": {
      "button": "Look at the shop",
      "running": "Looking …",
      "intro": "Connects, counts what is there, and shows a few rows as they would look in here. Nothing is written to Dandomain or to smibo, so it is safe to run in the middle of a busy day.",
      "heading": "What is in Dandomain",
      "failed": "Could not look at the shop.",
      "notConnected": "Could not connect to Dandomain.",
      "atLeast": "at least {count}",
      "window": "{from} – {to}",
      "noRows": "No rows."
    },
    "columns": {
      "phase": "Step",
      "seen": "Found",
      "created": "Created",
      "updated": "Updated",
      "skipped": "Skipped",
      "failed": "Errors",
      "started": "Started",
      "type": "Type",
      "result": "Result",
      "finished": "Finished"
    },
    "phase": {
      "Categories": "Categories",
      "Products": "Products",
      "Customers": "Customers",
      "Orders": "Orders"
    },
    "status": {
      "Running": "Running",
      "Completed": "Completed",
      "CompletedWithErrors": "Completed with errors",
      "Failed": "Failed",
      "Cancelled": "Cancelled"
    }
  },
  "reports": {
    "title": "Reports",
    "subtitle": "Measured on what has gone out, not on what has been ordered. All amounts include VAT.",
    "loadFailed": "Could not load the numbers.",
    "show": "Show",
    "revenue": "Revenue",
    "changeVsPrevious": "{change}% against the previous period",
    "noPrevious": "No revenue in the previous period",
    "ordersShipped": "Orders shipped",
    "shipmentCount": "{count} shipments",
    "averageOrder": "Average order",
    "beforeReturns": "Before returns",
    "refunded": "Refunded",
    "paidOutInPeriod": "Paid out in the period",
    "revenuePerDay": "Revenue per day",
    "bestSellers": "Best sellers",
    "nothingShipped": "Nothing shipped in the period.",
    "units": "Units",
    "vatInPeriod": "VAT in the period",
    "vatTotal": "VAT in total",
    "vatSplitHint": "Split by rate and by reason: reverse charge and export are both 0% and belong in different boxes.",
    "stockValue": "Stock value",
    "atCost": "At cost",
    "skusInStock": "Item numbers in stock",
    "unitsInStock": "Units",
    "withoutCostPrice": "{count} item numbers have stock but no cost price and count as zero. The value above is too low.",
    "noSalesIn": "No sales in {days} days",
    "everythingMoved": "Everything in stock has moved.",
    "valuePerMonth": "Value per month",
    "startedInPeriod": "Started in the period",
    "cancelledInPeriod": "Cancelled in the period",
    "quarterlyHint": "Quarterly subscriptions are converted to months, so the numbers can be added up."
  },
  "login": {
    "title": "Sign in",
    "subtitle": "Sign in to continue.",
    "rememberMe": "Keep me signed in",
    "forgotPassword": "Forgotten your password?",
    "resendConfirmation": "Send the confirmation link again",
    "confirmationSent": "Sent. Check your inbox — and your spam folder."
  },
  "notFound": {
    "body": "That page does not exist.",
    "back": "Back to the overview"
  },
  "members": {
    "subtitle": "Accounts in {workspace}. The same email address can belong to a different workspace independently.",
    "add": "Add member",
    "added": "Member added",
    "empty": "No members found.",
    "roles": "Roles",
    "role": "Role",
    "lastSignIn": "Last sign-in",
    "never": "Never",
    "active": "Active",
    "deactivated": "Deactivated",
    "deactivate": "Deactivate",
    "deactivateTitle": "Deactivate member",
    "deactivateFailed": "Could not deactivate",
    "loadFailed": "Could not load the members.",
    "deactivateBody": "{name} will no longer be able to sign in. Their history is kept.",
    "platformAccount": "Platform account",
    "invitationHint": "No password is created. Your colleague gets a link and chooses their own.",
    "invited": "The member has been created",
    "invitationLinkBody": "Send this link to your colleague. It is shown only now, and it has also been emailed."
  },
  "signUpWorkspace": {
    "title": "Create a workspace",
    "subtitle": "You will be its first owner.",
    "workspaceName": "Workspace name",
    "address": "Workspace address",
    "addressHint": "Used as your subdomain and workspace header.",
    "checking": "Checking availability…",
    "available": "{slug} is available",
    "unavailable": "That address is taken.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Work email",
    "password": "Password",
    "passwordHint": "At least 10 characters, with upper and lower case, a digit and a symbol.",
    "submit": "Create workspace",
    "haveOne": "Already have a workspace? {signIn}",
    "signIn": "Sign in",
    "noServer": "Could not reach the server. Is the API running?"
  },
  "dashboard": {
    "subtitle": "What is waiting right now.",
    "refresh": "Refresh the overview",
    "loadFailed": "Could not load the overview.",
    "needsAction": "Needs attention:",
    "allClear": "Nothing outstanding. Well done.",
    "configuredUnder": "The panels are chosen per workspace under {settings}.",
    "settingsLink": "settings",
    "widget": {
      "orders": {
        "new": {
          "title": "New orders",
          "hint": "Received, not touched yet"
        },
        "ready": {
          "title": "Ready to pack",
          "hint": "Everything is allocated on the shelf"
        },
        "backordered": {
          "title": "Backordered",
          "hint": "Waiting on an agreed delivery date"
        }
      },
      "purchasing": {
        "needed": {
          "title": "Not ordered yet",
          "hint": "Items on orders that are neither in stock nor on order"
        },
        "overdue": {
          "title": "Late deliveries",
          "hint": "Purchase orders past their expected delivery date"
        }
      },
      "subscriptions": {
        "due": {
          "title": "Subscriptions due",
          "hint": "Charged and shipped soon"
        },
        "failed": {
          "title": "Subscriptions with failed payment",
          "hint": "Payment failed repeatedly"
        }
      },
      "stock": {
        "low": {
          "title": "Low stock",
          "hint": "Products below their minimum stock"
        }
      },
      "messages": {
        "failed": {
          "title": "Messages that failed",
          "hint": "Could not be sent after several tries"
        }
      }
    },
    "detail": {
      "oldestToday": "The oldest arrived today",
      "oldestDays": "The oldest is {count} day old | The oldest is {count} days old",
      "nothingReady": "Nothing ready right now",
      "packableNow": "Can be packed straight away",
      "allOnOrder": "Everything is on order",
      "unitsWaiting": "{count} pcs customers are waiting for",
      "awaitingDate": "Waiting on an agreed delivery date",
      "shouldHaveArrived": "Should have arrived",
      "overdueCount": "{count} is overdue | {count} are overdue",
      "withinSevenDays": "Within 7 days",
      "contactCustomer": "The customer needs contacting",
      "belowMinimum": "Below minimum stock",
      "neverArrived": "Never arrived"
    }
  },
  "products": {
    "title": "Products",
    "copy": {
      "edit": "Edit text",
      "saved": "Text saved",
      "reset": "Take from the shop again",
      "ownedByShop": "The text comes from the shop and is refreshed by every data migration.",
      "ownedHere": "The text was written here {at} and the data migration leaves it alone.",
      "confirmReset": "Hand the text back to the shop? The words stay, but the next data migration overwrites them.",
      "tagsHint": "Separated by commas.",
      "slugHint": "The address the product lives at, without the domain. Changing it leaves existing links pointing at nothing."
    },
    "ai": {
      "title": "AI product-copy proposal",
      "generate": "Create AI proposal",
      "showDraft": "Show AI proposal",
      "regenerate": "Create new proposal",
      "generateFailed": "The AI proposal could not be created",
      "draft": "Draft",
      "intro": "This proposal applies to the complete product family of {count} variant(s). Edit it and select the fields to use.",
      "review": "Always verify the facts. The AI only received product information already stored in the platform.",
      "stale": "Product data changed after this proposal was created. Generate a new one before applying it.",
      "htmlHint": "Simple HTML is allowed in the description.",
      "searchPhrases": "Search phrases",
      "searchPhrasesHint": "For editorial work and internal search. Shopify and Google do not use meta keywords.",
      "notPublished": "Approval saves to the platform but does not publish to Shopify automatically.",
      "apply": "Apply selected fields",
      "applied": "The proposal was saved to {count} variant(s)",
      "discard": "Discard proposal",
      "confirmDiscard": "Discard this AI proposal? Product data will not change.",
      "errors": {
        "noGenerator": "OpenAI is not configured under Integrations.",
        "monthlyLimit": "The workspace reached its monthly product-optimisation limit.",
        "productNotFound": "The product does not exist.",
        "suggestionNotFound": "The AI proposal does not exist.",
        "notDraft": "The proposal has already been completed.",
        "stale": "Product data changed after this proposal was created. Generate a new one.",
        "noFields": "Select at least one field."
      }
    },
    "detail": {
      "sku": "Item number",
      "ean": "Barcode",
      "retailPrice": "Sales price",
      "guidelinePrice": "RRP",
      "allowPurchaseWhenOutOfStock": "Purchase when out of stock",
      "stockPolicy": { "allowed": "Allowed", "denied": "Not allowed", "unknown": "Unresolved" },
      "costPrice": "Cost price",
      "stock": "Stock",
      "weight": "Weight",
      "unit": "Unit",
      "location": "Location",
      "supplier": "Supplier",
      "categories": "Categories",
      "primary": "Primary",
      "siblings": "Other variants",
      "shortDescription": "Short description",
      "description": "Description",
      "longDescription": "Extended text",
      "tags": "Tags",
      "seo": "Search engines",
      "seoTitle": "Title",
      "seoSlug": "Address",
      "seoDescription": "Description",
      "seoKeywords": "Keywords",
      "noImages": "No images",
      "active": "Active",
      "inactive": "Not active",
      "source": "Imported from {channel}",
      "openInShop": "View in the shop"
    },
    "policy": {
      "title": "Sales and visibility",
      "familyHint": "The change applies to every variant in the product family. Stock quantities are unchanged.",
      "lifecycleLabel": "Lifecycle",
      "visibilityLabel": "Storefront visibility",
      "supplyLabel": "Supply method",
      "reason": "Reason",
      "reasonPlaceholder": "e.g. ordered from supplier after sale",
      "auditHint": "The before and after values are kept in the change history.",
      "sync": {
        "queued": "Shopify pending",
        "processing": "Updating Shopify",
        "completed": "Shopify reconciled",
        "failed": "Shopify retrying",
        "needsAttention": "Shopify needs attention"
      },
      "lifecycle": {
        "draft": "Draft",
        "readyForReview": "Ready for review",
        "approved": "Approved",
        "rejected": "Rejected",
        "archived": "Archived"
      },
      "visibility": {
        "unspecified": "Unresolved",
        "hidden": "Hidden",
        "whenInStock": "Visible with available stock",
        "always": "Always visible"
      },
      "supply": {
        "unspecified": "Unresolved",
        "stocked": "Stocked item",
        "orderOnDemand": "Ordered on demand",
        "dropShip": "Dropship",
        "service": "Service"
      }
    },
    "manual": {
      "create": "Create product",
      "createDraft": "Create draft",
      "created": "Product draft created",
      "name": "Product name",
      "draftHint": "The product is created as a hidden draft. Add its category and content, then choose its sales rules under Edit product."
    },
    "subtitle": "Stock, location and supplier. The name and the price come from the shop.",
    "searchPlaceholder": "Item no., name, barcode",
    "allSuppliers": "All suppliers",
    "allBrands": "All brands",
    "noBrand": "No brand",
    "belowMinimum": "Below minimum",
    "withoutSupplier": "No supplier",
    "empty": "No products found.",
    "loadFailed": "Could not load the products.",
    "saved": "The product is saved",
    "freeOfOnHand": "{free} free of {onHand}",
    "onTheWay": "{count} on the way",
    "supplierMissing": "Missing",
    "notPurchased": "Not purchased",
    "adjustStock": "Adjust stock",
    "editProduct": "Edit product",
    "stockAdjusted": "Stock adjusted",
    "stockAdjustFailed": "Stock was not adjusted",
    "stockIntro": "{name} — counted stock. Allocations are worked out again straight away, so anything spare is released to whoever is waiting.",
    "reasonPlaceholder": "e.g. stocktake, shrinkage, return",
    "pickLocationPlaceholder": "e.g. B-04-2",
    "noCategory": "No category",
    "choose": "Choose",
    "primaryCategoryHint": "The category the product \"belongs to\" — the one shown in breadcrumbs. With none chosen, the first one is used.",
    "restockHint": "Normally set automatically when a purchase order is marked as ordered.",
    "excludeFromPurchasing": "Never ordered in",
    "excludeHint": "For services and gift wrapping — never holds an order back and never appears in purchasing.",
    "variantCount": "{count} variants",
    "partlyActive": "{count} active",
    "stockFilter": {
      "any": "All stock",
      "inStock": "In stock",
      "outOfStock": "Out of stock",
      "belowMinimum": "Below minimum"
    },
    "sort": {
      "name": "Sort: name",
      "stockDescending": "Sort: most in stock",
      "stockAscending": "Sort: least in stock"
    },
    "columns": {
      "location": "Location",
      "demand": "Demand",
      "price": "Price",
      "state": "Status"
    },
    "fields": {
      "minimumStock": "Minimum stock",
      "pickLocation": "Pick location",
      "supplierSku": "Supplier's item no.",
      "restockExpected": "Expected in stock",
      "primaryCategory": "Primary category",
      "countedStock": "Counted stock"
    },
    "errors": {
      "minimumStockNegative": "Minimum stock cannot be negative.",
      "supplierNotFound": "That supplier does not exist.",
      "brandNotFound": "That brand does not exist.",
      "stockReasonRequired": "Give a reason for the stock adjustment.",
      "categoriesNotFound": "One or more of the categories do not exist.",
      "primaryNotAmongChosen": "The primary category has to be one of the chosen ones."
    },
    "missing": {
      "none": "All products",
      "image": "No image",
      "costPrice": "No cost price",
      "costPriceWithStock": "Stock with no cost price",
      "supplier": "No supplier",
      "brand": "No brand",
      "description": "No description",
      "weight": "No weight",
      "ean": "No barcode",
      "weightSuspect": "Weight that cannot be right"
    },
    "gaps": {
      "label": "Gaps in the catalogue:",
      "of": "of {total} products",
      "fillWeight": "Fill {count} from the supplier catalogues",
      "fillWeightNone": "The supplier catalogues have no weight for them",
      "fillWeightDone": "Weight set on {filled} SKUs from the supplier catalogues.",
      "fillWeightDisagree": "{count} barcodes where two suppliers disagree on the weight — filled with the first:"
    }
  },
  "brands": {
    "title": "Brands",
    "subtitle": "The makes in the catalogue, and the shop numbers that do not have a name yet.",
    "newBrand": "New brand",
    "editBrand": "Edit brand",
    "name": "Name",
    "sourceId": "Shop id",
    "sourceIdHint": "Dandomain's producer id. Filling it in hands the brand every product carrying it.",
    "active": "Shown in lists",
    "hidden": "Hidden",
    "productCount": "{count} products",
    "empty": "There are no brands yet.",
    "loadFailed": "The brands could not be loaded.",
    "saved": "Brand saved",
    "claimed": "{count} products now belong to {name}.",
    "nameIt": "Give it a name",
    "nameItAs": "Call it {name}",
    "merge": "Merge into another brand",
    "mergeInto": "Merge into",
    "mergeIntro": "{name} has {count} products. They move to the brand you pick, and {name} is deleted.",
    "merged": "Brands merged",
    "confirmDelete": "Delete the brand {name}?",
    "unmapped": {
      "title": "No name yet",
      "intro": "Dandomain reports only a number for a brand and has no endpoint that looks the name up. {count} products are waiting for a name — the largest first. The suggestion is the words their titles share; read it before saving."
    }
  },
  "variantTypes": {
    "title": "Variant types",
    "subtitle": "The axes the range varies along — colour, size, length — and the values on each.",
    "newType": "New type",
    "editType": "Edit type",
    "newValue": "New value",
    "editValue": "Edit value",
    "name": "Name",
    "sortOrder": "Order",
    "active": "Shown in lists",
    "hidden": "Hidden",
    "colorHex": "Colour code",
    "colorHint": "A hex code such as #1b3a4b. It paints the swatch — a name like \"Petrol\" says less than the square does.",
    "imageUrl": "Image",
    "valueCount": "{count} values",
    "noValues": "No values on this type yet.",
    "empty": "There are no variant types yet. They arrive with the next data migration, or you can create them here.",
    "loadFailed": "The variant types could not be loaded.",
    "unusedHint": "{count} values are not used by any product. They are dimmed in the list.",
    "confirmDeleteType": "Delete the type {name}? Only possible if no products use it.",
    "confirmDeleteValue": "Delete the value {name}?",
    "colorPlaceholder": "#1b3a4b"
  },
  "categories": {
    "title": "Categories",
    "subtitle": "How the shop is structured. A product can sit in several categories but always has one primary.",
    "newCategory": "New category",
    "editCategory": "Edit category",
    "empty": "There are no categories yet.",
    "loadFailed": "Could not load the categories.",
    "saved": "The category is saved",
    "deleteTitle": "Delete category",
    "deleteBody": "Delete \"{name}\"? That is only possible while it has neither subcategories nor products.",
    "deleted": "The category is deleted",
    "deleteFailed": "Could not delete",
    "hidden": "Hidden",
    "addChild": "Add subcategory",
    "topLevel": "— None (top level) —",
    "noCycleHint": "Subcategories of this one cannot be chosen — it would make a loop.",
    "sortOrderHint": "Lowest number first among categories at the same level.",
    "visibleInShop": "Shown in the shop",
    "fields": {
      "name": "Name",
      "parent": "Sits under",
      "sortOrder": "Order",
      "description": "Description"
    },
    "errors": {
      "nameRequired": "A name is required.",
      "hasChildren": "The category has subcategories. Move them first.",
      "hasProducts": "The category has products. Move them first, or deactivate it.",
      "wouldCreateCycle": "A category cannot sit under itself or under one of its own subcategories."
    },
    "searchPlaceholder": "Search categories",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "count": "{shown} of {total}"
  },
  "orders": {
    "title": "Orders",
    "subtitle": "Search every order, shipped and cancelled ones included.",
    "searchPlaceholder": "Order no., customer, email or item no.",
    "empty": "No orders found.",
    "loadFailed": "Could not load the orders.",
    "columns": {
      "order": "Order",
      "date": "Date",
      "customer": "Customer",
      "status": "Status",
      "payment": "Payment",
      "amount": "Amount"
    },
    "age": {
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "errors": {
      "notFound": "That order does not exist.",
      "closed": "The order is closed.",
      "lineNotFound": "That order line does not exist.",
      "alreadyBeingPicked": "Somebody else is already picking this order.",
      "quantityNegative": "A quantity cannot be negative.",
      "quantityAtLeastOne": "The quantity has to be at least 1.",
      "priceNegative": "A price cannot be negative.",
      "shippingNegative": "Shipping cannot be negative.",
      "nothingToCancel": "There is nothing outstanding on the line to cancel.",
      "productNotFound": "That product does not exist.",
      "scanEmpty": "Scan a barcode.",
      "nothingPicked": "Nothing has been picked yet.",
      "notReadyForPickup": "The order is not ready for pickup.",
      "alreadyDispatched": "The order has already been sent.",
      "subjectRequired": "A subject is required.",
      "onlyAllocated": "Only {count} pcs are allocated to this order.",
      "alreadyShipped": "{count} pcs have already shipped. Use a return instead.",
      "scanNotOnOrder": "{code} does not belong to this order. Put it back.",
      "scanAlreadyComplete": "{name}: {count} pcs are already in the box, and no more are allocated.",
      "scanNothingReserved": "{name} is on the order, but no stock is allocated to it. It does not go in this parcel.",
      "scanCancelled": "{name} is cancelled on this order. Put it back."
    },
    "status": {
      "Received": "Received",
      "InProgress": "In progress",
      "PartiallyShipped": "Partially shipped",
      "Shipped": "Shipped",
      "ReadyForPickup": "Ready for pickup",
      "PickedUp": "Picked up",
      "Cancelled": "Cancelled",
      "Refunded": "Refunded"
    },
    "fulfillment": {
      "Ready": "Ready to pack",
      "PartiallyReady": "Partly ready",
      "Backordered": "Backordered",
      "AwaitingStock": "Not ordered yet",
      "Complete": "Done"
    },
    "fulfillmentHint": {
      "Ready": "Everything is in stock and allocated",
      "PartiallyReady": "Some of it can ship now",
      "Backordered": "Waiting for the agreed delivery date",
      "AwaitingStock": "Has to be ordered in",
      "Complete": "Nothing outstanding"
    },
    "lineStatus": {
      "Waiting": "Waiting",
      "Allocated": "Allocated",
      "Picked": "Picked",
      "Shipped": "Shipped",
      "Cancelled": "Cancelled"
    },
    "paymentStatus": {
      "None": "No payment",
      "Authorized": "Authorised",
      "Captured": "Captured",
      "PartiallyRefunded": "Partly refunded",
      "Refunded": "Refunded",
      "Failed": "Failed"
    },
    "vatTreatment": {
      "Domestic": "Domestic VAT",
      "OssEuB2c": "EU consumer (OSS)",
      "ReverseCharge": "Reverse charge",
      "Export": "Export outside the EU",
      "Exempt": "VAT exempt"
    }
  },
  "orderDetail": {
    "crumb": "Order {number}",
    "back": "Back to the packing list",
    "loadFailed": "Could not load the order.",
    "packingSlip": "Packing slip",
    "messageCustomer": "Write to the customer",
    "startPicking": "Start picking",
    "pickingStarted": "You are picking this order",
    "abandonPicking": "Stop picking",
    "pickingAbandoned": "Picking stopped",
    "pickAllAllocated": "Pick everything allocated",
    "allPicked": "Everything allocated has been picked",
    "finishAndSend": "Finish and send",
    "markReadyForPickup": "Mark ready for pickup",
    "readyForPickup": "Ready for pickup",
    "dispatched": "The order has been sent",
    "confirmPickup": "Confirm pickup",
    "markedPickedUp": "Marked as picked up",
    "cancelTitle": "Cancel order",
    "cancelBody": "Allocated stock is released to the next orders in the queue. Anything already shipped is untouched.",
    "cancelConfirm": "Cancel the order",
    "cancelled": "The order is cancelled",
    "unitsPicked": "{count} picked",
    "completeOn": "complete {date}",
    "pickedBy": "{name} is packing this order",
    "pickedSince": "(since {time})",
    "customerNote": "Note from the customer:",
    "scanPlaceholder": "Scan a barcode — one scan per item",
    "scanAccepted": "{code} in the box",
    "scanRejected": "The scan was rejected.",
    "unknownProduct": "That item number is not in the catalogue — it cannot be allocated automatically.",
    "restockExpected": "expected {date}",
    "noRestockDate": "no delivery date",
    "figures": {
      "allocated": "Allocated"
    },
    "shipments": "Shipments",
    "printLabel": "Print label",
    "printAgain": "Print again",
    "pickupCarrier": "Pickup",
    "awaitingChannelSync": "waiting to reach the shop",
    "shippingAddress": "Shipping address",
    "attentionOf": "attn. {name}",
    "delivery": "Delivery",
    "method": "Method",
    "servicePoint": "Service point",
    "shipping": "Shipping",
    "payment": "Payment",
    "goods": "Goods",
    "discount": "Discount",
    "totalExVat": "Total excl. VAT",
    "vat": "VAT",
    "buyerVatNumber": "Buyer's VAT no.",
    "total": "Total",
    "authorized": "Authorised",
    "internalNote": "Internal note",
    "internalOnly": "Only visible internally",
    "noteSaved": "The note is saved",
    "noteSaveFailed": "The note was not saved",
    "dispatchIntro": "{count} pcs are recorded as sent and taken off the shelf.",
    "dispatchIntroPickup": "{count} pcs are recorded as ready in the shop and taken off the shelf.",
    "trackingNumber": "Tracking number",
    "message": {
      "defaultSubject": "About your order {number}",
      "intro": "Sent to {email} and kept on the order, so the reply can be found again.",
      "subject": "Subject",
      "body": "Message",
      "variablesHint": "You can use {sender} and {support} the same way as in the templates.",
      "send": "Send",
      "sent": "Message sent",
      "notSent": "The message was not sent",
      "seeLog": "See the message log.",
      "sendFailed": "Could not send"
    }
  },
  "packing": {
    "title": "Packing list",
    "subtitle": "Orders still to go out. The ones that can be packed right now are at the top.",
    "loadFailed": "Could not load the packing list.",
    "printSelected": "Print {count} packing slip | Print {count} packing slips",
    "printAllReady": "Print all ready ({count})",
    "updatedAt": "Updated {time}",
    "refresh": "Refresh the list",
    "truncated": "There are more open orders than the list shows. Use the search field to narrow it down.",
    "filter": "Filter: {state}",
    "clearFilter": "Clear filter",
    "orderCount": "{count} orders",
    "empty": "No orders waiting. Well done.",
    "needsPurchasing": "Has to be ordered",
    "allocated": "{allocated}/{outstanding} pcs allocated",
    "unitsShort": "{count} pcs short",
    "completeOn": "Complete {date}",
    "customerNote": "Customer note",
    "internalNote": "Internal note",
    "internalNoteTooltip": "There is an internal note on this order",
    "pack": "Pack",
    "open": "Open",
    "columns": {
      "coverage": "Coverage",
      "delivery": "Delivery"
    }
  },
  "packingSlips": {
    "title": "Packing slip",
    "print": "Print",
    "slipCount": "{count} packing slip | {count} packing slips",
    "noneSelected": "No orders selected.",
    "loadFailed": "Could not load the orders.",
    "shipTo": "Ship to",
    "pickup": "Collected in the shop",
    "servicePoint": "Service point {id}",
    "follows": "{count} pcs to follow",
    "customerNote": "Note from the customer",
    "footer": "Thank you for your order. If anything needs to go back, contact us first and we will sort it out.",
    "columns": {
      "location": "Location",
      "sku": "Item no.",
      "product": "Product",
      "quantity": "Qty"
    }
  },
  "shippingRules": {
    "title": "Shipping rules",
    "subtitle": "Decides which carrier product is booked when an order ships. The rules are read top to bottom — the first one that fits wins.",
    "newRuleButton": "New rule",
    "newRule": "New shipping rule",
    "editRule": "Edit shipping rule",
    "loadFailed": "Could not load the shipping rules.",
    "saved": "Saved",
    "saveFailed": "Could not save the rule.",
    "deleteTitle": "Delete shipping rule",
    "deleteBody": "Delete \"{description}\"? Orders that matched it fall through to the next rule.",
    "deleteFailed": "Could not delete the rule.",
    "noRules": "There are no shipping rules. Without at least one, no label is booked when an order ships — the parcel is recorded as sent with no shipping label.",
    "noLabel": "No label",
    "active": "Active",
    "inactive": "Switched off",
    "all": "All",
    "lowestWins": "Lowest number wins.",
    "appliesTo": "Applies to",
    "thenBook": "Then book",
    "noLabelHint": "Leave the carrier and the product code empty if the order should not have a label.",
    "descriptionPlaceholder": "e.g. GLS service point, Denmark",
    "carrierPlaceholder": "e.g. gls",
    "serviceCodePlaceholder": "e.g. GLSDK_SD",
    "addOnsPlaceholder": "e.g. EMAIL_NT,SMS_NT",
    "columns": {
      "priority": "No.",
      "rule": "Rule",
      "product": "Carrier product"
    },
    "fields": {
      "description": "Description",
      "order": "Order",
      "method": "Delivery method from the shop",
      "country": "Country",
      "countryCode": "Country code",
      "pickup": "Pickup",
      "servicePoint": "Service point chosen",
      "carrier": "Carrier",
      "serviceCode": "Product code",
      "addOns": "Add-ons"
    },
    "tristate": {
      "any": "Does not matter",
      "yes": "Yes",
      "no": "No"
    },
    "criteria": {
      "method": "Delivery method {code}",
      "country": "Country {code}",
      "pickup": "Pickup",
      "notPickup": "Not pickup",
      "servicePoint": "Service point chosen",
      "noServicePoint": "No service point",
      "everything": "Every order"
    },
    "test": {
      "title": "Try an order",
      "intro": "Fill it in like a real order and see which rule wins. Nothing is booked.",
      "methodPlaceholder": "e.g. 7",
      "run": "Try it",
      "hit": "Hits {rule} → {carrier}",
      "noLabel": "no label",
      "noMatch": "No rule fits. An order like this ships without a label."
    }
  },
  "purchasing": {
    "title": "Purchasing",
    "subtitle": "What is missing — for the customers waiting, and to fill the shelf back up.",
    "loadSuggestionsFailed": "Could not load the purchase suggestions.",
    "toPurchaseOrders": "Purchase orders",
    "nothingToOrder": "There is nothing to order right now.",
    "summary": "{units} pcs across {suppliers} suppliers",
    "orderDayToday": "Order day today",
    "missingSupplier": "No supplier",
    "leadTimeDays": "{count} days lead time",
    "createOrder": "Create purchase order",
    "noSupplierBody": "These products have no supplier and cannot be ordered automatically. Assign one on the {productPage}.",
    "noSupplierLink": "product page",
    "belowMinimum": "The order is below the supplier's minimum of {amount}",
    "noProductsSelected": "No products selected",
    "draftCreated": "Draft {number} created",
    "createFailed": "Could not create the purchase order",
    "lineCount": "{count} lines",
    "ourSku": "ours {sku}",
    "waitingOrders": "{count} order | {count} orders",
    "freeStock": "{count} free",
    "minimumStock": "min. {count}",
    "receivedOfOrdered": "{received}/{ordered} pcs",
    "noFixedOrderDays": "No fixed days",
    "noSupplierGroup": "No supplier",
    "errors": {
      "supplierNotFound": "That supplier does not exist.",
      "noLines": "Pick at least one product with a quantity above zero.",
      "productsGone": "One or more of the products no longer exist.",
      "orderNotFound": "That purchase order does not exist.",
      "alreadySent": "The purchase order has already been sent.",
      "sendBeforeReceiving": "Send the purchase order before receiving goods on it.",
      "orderCancelled": "The purchase order is cancelled.",
      "lineNotOnOrder": "One of the lines is not on the order.",
      "negativeReceipt": "Fewer than zero cannot be received.",
      "barcodeRequired": "Type or scan a barcode.",
      "barcodeNotOnOrder": "That barcode is not on this purchase order.",
      "alreadyReceived": "The purchase order has already been received."
    },
    "columns": {
      "product": "Product",
      "waiting": "Customers waiting",
      "stock": "Stock",
      "incoming": "Incoming",
      "order": "Order",
      "cost": "Cost"
    },
    "status": {
      "Draft": "Draft",
      "Ordered": "Ordered",
      "PartiallyReceived": "Partially received",
      "Received": "Received",
      "Cancelled": "Cancelled"
    },
    "weekday": {
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday",
      "Sunday": "Sunday"
    },
    "weekdayShort": {
      "Monday": "Mon",
      "Tuesday": "Tue",
      "Wednesday": "Wed",
      "Thursday": "Thu",
      "Friday": "Fri",
      "Saturday": "Sat",
      "Sunday": "Sun"
    },
    "orders": {
      "title": "Purchase orders",
      "subtitle": "What has been ordered from suppliers, and where the delivery stands.",
      "toSuggestions": "To purchase suggestions",
      "loadFailed": "Could not load the purchase orders.",
      "openOnly": "Open only",
      "empty": "No purchase orders.",
      "columns": {
        "number": "Number",
        "supplier": "Supplier",
        "status": "Status",
        "ordered": "Ordered",
        "expected": "Expected",
        "received": "Received",
        "cost": "Cost"
      }
    },
    "detail": {
      "back": "Back to purchase orders",
      "loadFailed": "Could not load the purchase order.",
      "reference": "ref. {reference}",
      "downloadCsv": "Download CSV",
      "markOrdered": "Mark as ordered",
      "markedOrdered": "The purchase order is marked as ordered",
      "receiveAll": "Receive everything",
      "allReceived": "The whole delivery has been received",
      "lineReceived": "{name}: {change} pcs",
      "scanReceived": "{ean} received",
      "cancelTitle": "Cancel purchase order",
      "cancelBody": "The expected delivery date is cleared from the products, so customer orders stop promising a date that is not coming.",
      "cancelConfirm": "Cancel the order",
      "cancelled": "The purchase order is cancelled",
      "overdue": "The delivery is late — expected {date}.",
      "receivedSummary": "{count} pcs received",
      "expectedOn": "expected {date}",
      "orderedAt": "ordered {date}",
      "scanLabel": "Scan a barcode to receive",
      "barcode": "Barcode",
      "receiveOne": "Receive 1 pc",
      "lines": "Lines",
      "pickLocation": "bin {location}",
      "shortOnOrders": "{count} pcs short for customer orders",
      "complete": "Complete",
      "receiveCount": "Receive {count}",
      "outstanding": "{count} outstanding",
      "figures": {
        "ordered": "Ordered",
        "received": "Received",
        "inStock": "In stock"
      },
      "details": "Details",
      "fields": {
        "created": "Created",
        "ordered": "Ordered",
        "expected": "Expected",
        "completed": "Completed",
        "totalCost": "Total cost"
      },
      "note": "Note",
      "saveNote": "Save note",
      "noteSaved": "The note is saved",
      "noteSaveFailed": "The note was not saved",
      "sendIntro": "The expected date is put on the products, so waiting customer orders show a real delivery date instead of \"not ordered yet\".",
      "expectedDelivery": "Expected delivery",
      "supplierReference": "Supplier's reference"
    }
  },
  "campaigns": {
    "title": "Mail suggestions",
    "subtitle": "Five concrete campaign suggestions, written from what the shop has sent before, what sold in the period, and what you said about the last round.",
    "errors": {
      "noGenerator": "No language model is configured to write suggestions. Nothing can be generated without one.",
      "periodBackwards": "The end date is before the start date.",
      "noCandidates": "No products can be shown in a campaign — they have no picture, or nothing is in stock.",
      "nothingGenerated": "No suggestions came back.",
      "monthlyLimit": "This workspace has used its share of suggestions this month. The limit exists so one enthusiastic afternoon cannot spend the platform account before anyone notices.",
      "noKlaviyo": "This workspace has no Klaviyo account.",
      "notFound": "The suggestion does not exist."
    },
    "generate": "Write suggestions",
    "generating": "Writing …",
    "periodFrom": "Period from",
    "periodTo": "Period to",
    "theme": "Theme",
    "themeHint": "Optional. For example \"summer sale\" or \"new riding helmets\".",
    "periodHint": "Usually the same weeks last year — that is where a season looks like itself.",
    "loadFailed": "Could not load the suggestions.",
    "generateFailed": "Could not write suggestions.",
    "empty": "No suggestions yet.",
    "active": "Active",
    "archive": "Archive",
    "batch": "Round {date}",
    "basedOn": "Built on {name}",
    "subjectOptions": "Subject lines",
    "previewOptions": "Preview text",
    "products": "Products in the mail",
    "feedback": "What you like about it",
    "feedbackHint": "This is sent along next time as an example of your voice. It is what makes the suggestions better over time.",
    "approve": "Approve",
    "approved": "Approved",
    "archiveIt": "Archive",
    "saveFailed": "Could not save.",
    "status": {
      "Draft": "Draft",
      "Approved": "Approved",
      "SentToKlaviyo": "Sent to Klaviyo",
      "Discarded": "Discarded"
    },
    "type": {
      "ReuseTop": "Reuse the best",
      "ReworkSamePeriod": "Same period, reworked",
      "ProductHighlight": "Single product",
      "CategoryCampaign": "Category",
      "SaleCampaign": "Sale",
      "Seasonal": "Seasonal",
      "AiVariant": "Variant"
    },
    "klaviyo": {
      "title": "Klaviyo",
      "subtitle": "This shop own account — every shop has its own list, its own history and its own bill. The key is never shown again; leave the field empty to keep the stored one.",
      "apiKey": "API key",
      "alreadySet": "A key is stored",
      "save": "Save",
      "saved": "Saved",
      "test": "Test",
      "sync": "Fetch campaigns",
      "synced": "{created} new and {updated} updated campaigns",
      "lastSync": "Last fetched {when} — {count} campaigns."
    },
    "settings": {
      "title": "How we write",
      "subtitle": "The shop's own voice. Read verbatim every time suggestions are written — and one written without it sounds like every other shop's.",
      "saved": "Saved",
      "brandName": "Shop name",
      "senderName": "Sender name",
      "senderEmail": "Sender address",
      "language": "Language",
      "toneOfVoice": "Tone",
      "targetAudience": "Audience",
      "greetingStyle": "Greeting",
      "signature": "Signature",
      "emojiUsage": "Emoji",
      "subjectStyle": "Subject lines",
      "ctaStyle": "Call to action",
      "doList": "Do",
      "dontList": "Avoid",
      "discountPolicy": "Discount policy",
      "preferredSendDays": "Best send days",
      "extraNotes": "Anything else",
      "readStyle": "Read the voice from earlier campaigns",
      "readStyleHint": "Read from {count} earlier campaigns. The suggestions describe how the shop has written — not how it should.",
      "tooFewCampaigns": "There are only {count} earlier campaigns. At least {minimum} are needed before a pattern means anything.",
      "use": "Use this one"
    },
    "pdf": "Download as PDF",
    "pdfFailed": "The PDF could not be created.",
    "basedOnShort": "Based on",
    "voiceEmpty": "The shop's voice has not been filled in, so the suggestions will be written for a shop in general rather than for yours. Fill it in under"
  },
  "platform": {
    "title": "Operations",
    "subtitle": "The shop's data: empty it, or take a copy. Super-admin only.",
    "workspace": "Shop",
    "members": "Members",
    "created": "Created",
    "name": "Name",
    "loadFailed": "Could not load the shop.",
    "empty": "Empty",
    "emptyTitle": "Empty {name}",
    "emptyWarning": "Deletes products, customers, orders, suppliers, purchasing, subscriptions and the message log. This cannot be undone.",
    "emptyKeeps": "The shop remains: members, roles, settings, VAT setup, message templates, own wording, shipping rules and the carrier and channel credentials.",
    "emptyConfirm": "Type {slug} to confirm",
    "emptied": "Emptied — {count} rows deleted.",
    "emptyFailed": "The shop could not be emptied.",
    "export": "Export",
    "errors": {
      "unknownSetting": "Unknown setting."
    }
  },
  "integrations": {
    "title": "Connections",
    "subtitle": "What has to be plugged in, where it is set, and what is missing. Values are never shown — only whether there is one.",
    "platform": "The agency own accounts",
    "platformHint": "One account for every shop. Set outside the database, so no screen — and no customer administrator — can read or change it.",
    "tenant": "Each shop own accounts",
    "tenantHint": "Every shop has its own. Set on the screen for the workspace it belongs to.",
    "tabs": {
      "platform": "Platform",
      "shops": "Shops",
      "shipping": "Shipping",
      "marketing": "Marketing",
      "overview": "Overview"
    },
    "listModels": "List models",
    "chooseModel": "Choose a model",
    "saveKeyFirst": "Save the API key first",
    "save": "Save",
    "clear": "Clear",
    "saved": "Saved",
    "saveFailed": "Could not save.",
    "fromScreen": "Typed in here",
    "fromConfiguration": "Comes from configuration — type here to override.",
    "stillInConfig": "Two things cannot move in here: the keyring certificate, because it protects the thing that would protect these fields, and the list of platform administrators, because it decides who may see this page. Both are set in configuration.",
    "group": {
      "openAi": "OpenAI",
      "mail": "Outgoing mail",
      "general": "General"
    },
    "groupHint": {
      "openAi": "Writes campaign and product proposals. One account for every shop; usage is recorded per proposal.",
      "mail": "Sends all outgoing post. Without a key, messages are written to the log and not delivered.",
      "general": "Applies to the whole installation."
    },
    "setting": {
      "OpenAi:ApiKey": "API key",
      "OpenAi:Model": "Model",
      "OpenAi:MonthlyBatchesPerTenant": "Batches per workspace per month",
      "OpenAi:MonthlyProductOptimizationsPerTenant": "Product proposals per workspace per month",
      "Mail:Mandrill:ApiKey": "Mandrill API key",
      "Mail:SenderEmail": "Default sender",
      "Mail:SenderName": "Sender name",
      "PublicUrl": "Public address"
    },
    "settingHint": {
      "OpenAi:ApiKey": "Takes effect immediately — no restart.",
      "OpenAi:Model": "Models load automatically using the saved API key. Choose a model, then press Save.",
      "OpenAi:MonthlyBatchesPerTenant": "A guard against a runaway afternoon, not a budget. 0 removes the limit.",
      "OpenAi:MonthlyProductOptimizationsPerTenant": "A separate usage ceiling for product copy. 0 removes the limit.",
      "Mail:Mandrill:ApiKey": "The domain must be verified per shop — Mandrill accepts mail from an unverified one and quietly lands it in spam.",
      "Mail:SenderEmail": "Used when a workspace has not set a sender of its own.",
      "Mail:SenderName": "The name that appears in the recipient inbox.",
      "PublicUrl": "The address that appears in links in emails. Without it they render empty."
    },
    "configured": "Set",
    "missing": "Missing",
    "notBuilt": "Not built yet",
    "setIn": "Set in",
    "open": "Open the screen",
    "loadFailed": "Could not load the connections.",
    "howTo": "Set a value with user secrets locally, or as an environment variable in production. A colon becomes a double underscore in an environment variable.",
    "name": {
      "openAi": "OpenAI",
      "mandrill": "Mandrill",
      "publicUrl": "Public address",
      "dataProtection": "Keyring certificate",
      "forwardedHeaders": "Load balancer",
      "shopify": "Shopify",
      "dandomain": "Dandomain",
      "shipmondo": "Shipmondo",
      "supplierFeeds": "Supplier feeds",
      "klaviyo": "Klaviyo",
      "onpay": "OnPay"
    },
    "what": {
      "openAi": "Writes campaign suggestions and product-copy proposals.",
      "mandrill": "Sends all outgoing mail. The domain must be verified per shop.",
      "publicUrl": "The address that appears in links in emails. Without it they render empty.",
      "dataProtection": "Encrypts the keyring, which encrypts every credential in the database. Without it, database access is credential access.",
      "forwardedHeaders": "Which proxies may set the client IP. Without it the subdomain cannot decide the workspace behind a load balancer.",
      "shopify": "Shop, orders and product catalogue.",
      "dandomain": "Migration only — one-off and delta import.",
      "shipmondo": "Carrier accounts and labels.",
      "supplierFeeds": "Automatic fetching of price and stock files.",
      "klaviyo": "Campaign history and drafts. The key is set on Mail suggestions.",
      "onpay": "Subscription payments. Still to be built."
    }
  },
  "pim": {
    "title": "Supplier catalogue",
    "subtitle": "The suppliers' own product data. One product is one style in one colour; the variants are its sizes. Nothing is deleted for being absent from a file.",
    "errors": {
      "notFound": "The product does not exist.",
      "noFormat": "This supplier has no catalogue format set. Choose one on the supplier before importing a file.",
      "noParser": "There is no reader for that format.",
      "noVariants": "The product has no variants and cannot be put in the shop.",
      "noApprovedCategory": "The product's category has not been approved yet. Approve it under Categories before putting the product in the shop.",
      "noShopConnection": "This workspace has no Shopify connection.",
      "categoryNotFound": "The category does not exist.",
      "alreadyRunning": "A publish is already running."
    },
    "empty": "Nothing here yet. Import a catalogue file from the supplier.",
    "loadFailed": "Could not load the catalogue.",
    "columns": {
      "product": "Product",
      "color": "Colour",
      "sizes": "Sizes",
      "images": "Images",
      "category": "Category",
      "status": "Status",
      "path": "Supplier category",
      "products": "Products",
      "shopCategory": "Shop category",
      "brandCategory": "Brand category",
      "file": "File",
      "result": "Result",
      "started": "Started"
    },
    "supplier": "Supplier",
    "chooseSupplier": "Choose a supplier",
    "noSuppliers": "No supplier has a catalogue format yet. Set one on the supplier first.",
    "import": "Import catalogue file",
    "importing": "Importing …",
    "importDone": "The file has been read",
    "importFailed": "Could not read the file.",
    "search": "Search by name or article number",
    "allStatuses": "All",
    "job": {
      "queueDryRun": "Dry run on {count} selected",
      "queueLive": "Put {count} selected in the shop",
      "queued": "Queued",
      "queueFailed": "Could not queue the batch.",
      "progress": "{done} of {total}",
      "running": "Running",
      "cancel": "Stop",
      "cancelling": "Stopping after the product it is on",
      "dryRunLabel": "Dry run",
      "note": "Keeps going in the background — you can close the page.",
      "status": {
        "Queued": "Queued",
        "Running": "Running",
        "Completed": "Done",
        "CompletedWithErrors": "Done with errors",
        "Cancelled": "Stopped",
        "Failed": "Failed"
      }
    },
    "detail": {
      "noImages": "No pictures — the product goes into the shop without any.",
      "mainItem": "Style number",
      "origin": "Country of origin",
      "itemcode": "Article number",
      "ean": "Barcode",
      "weight": "Weight",
      "purchasePrice": "Purchase price",
      "retailPrice": "Recommended price",
      "ownCategory": "Own category for this product",
      "ownCategoryHint": "Wins over whatever the supplier category points at — this decision was made looking at this product."
    },
    "mapping": {
      "title": "Where the supplier categories land",
      "subtitle": "Decided per category, not per product. Nothing goes into the shop until the category is approved.",
      "manual": "Single product",
      "choose": "Choose a category",
      "declineBrand": "No brand category",
      "pdf": "Download PDF",
      "pdfFailed": "Could not make the PDF.",
      "basedOnShort": "Built on",
      "approve": "Approve",
      "save": "Save as a suggestion",
      "suggest": "Suggest from the shop",
      "suggested": "{paths} categories got a proposal from {recognised} of {total} products the shop already sells. {kept} were left alone because somebody had already decided.",
      "suggestedFromStyle": "{count} products the shop does not sell were proposed from other colours of the same style.",
      "readStyle": "Read from past campaigns",
      "readStyleHint": "Read from {count} sent campaigns. These are counts, not judgements — tone and audience can only be read by a language model, and none is configured yet.",
      "tooFewCampaigns": "There are {count} campaigns to read from, and at least {minimum} are needed. Campaigns come from Klaviyo, which is not connected yet.",
      "use": "Use",
      "saved": "Saved",
      "saveFailed": "Could not save the category.",
      "status": {
        "Suggested": "Suggested",
        "Approved": "Approved",
        "Rejected": "Not used"
      },
      "none": "Not chosen"
    },
    "publish": {
      "dryRun": "Dry run",
      "live": "Put in the shop",
      "running": "Working …",
      "heading": "Result",
      "dryRunNote": "A dry run writes nothing — not in the shop and not here.",
      "action": {
        "Created": "Would be created",
        "Updated": "Would be updated",
        "Failed": "Failed"
      },
      "actionDone": {
        "Created": "Created",
        "Updated": "Updated",
        "Failed": "Failed"
      },
      "variantsCreated": "{count} sizes created",
      "variantsUpdated": "{count} sizes updated",
      "imagesAdded": "{count} images uploaded",
      "failed": "Could not put the product in the shop."
    },
    "tabs": {
      "products": "Products",
      "categories": "Categories",
      "imports": "Imports"
    },
    "status": {
      "New": "New",
      "Published": "Published",
      "Rejected": "Rejected"
    }
  },
  "suppliers": {
    "title": "Suppliers",
    "subtitle": "Who the goods are ordered from, when they are ordered, and how long they take.",
    "back": "Back to suppliers",
    "newSupplier": "New supplier",
    "editSupplier": "Edit supplier",
    "loadFailed": "Could not load the suppliers.",
    "loadOneFailed": "Could not load the supplier.",
    "saved": "The supplier is saved",
    "deleteTitle": "Delete supplier",
    "deleteBody": "Delete \"{name}\"? That is only possible while it has neither products nor purchase orders on it.",
    "deleted": "The supplier is deleted",
    "deleteFailed": "Could not delete",
    "empty": "No suppliers yet. Create the first one to start ordering goods in.",
    "inactive": "Inactive",
    "wholesalerBrands": "Wholesaler · {count} brands",
    "orderedThrough": "Ordered through {name}",
    "noEmail": "No email",
    "customerNumber": "cust. no. {number}",
    "productCount": "{count} products",
    "lastImported": "last imported {date}",
    "priceFile": "Price file",
    "configured": "Configured",
    "notConfigured": "Not configured",
    "orderedDirectly": "Ordered directly",
    "isWholesalerHint": "This supplier is itself a wholesaler for other brands and so cannot be placed under one.",
    "wholesalerHint": "Choose a wholesaler and products from all of their brands are gathered onto one order, sent to the wholesaler's email.",
    "orderDaysHint": "Used to flag the supplier on the purchasing list on the right day.",
    "pimFormatHint": "Only for suppliers who send a product catalogue. The format decides which reader parses the file under Supplier catalogue.",
    "costPriceFactorHint": "Cost prices from the file are multiplied by this — 7.45 for euros, 0.9 for a 10% discount. The result is always stored in the workspace's own currency.",
    "invoicesInCurrency": "{name} invoices in {currency}",
    "currencyWithoutFactor": "{invoices}, but the conversion factor is 1. Cost prices will be stored as bare numbers, and every margin built on them will be wrong. Set the factor, or clear the currency.",
    "columns": {
      "name": "Name",
      "orderDays": "Order days",
      "leadTime": "Lead time",
      "minimumOrder": "Minimum order",
      "products": "Products",
      "priceFile": "Price file"
    },
    "fields": {
      "pimFormat": "Catalogue format",
      "noPimFormat": "Sends no catalogue",
      "name": "Name",
      "wholesaler": "Bought through a wholesaler",
      "email": "Email for orders",
      "contactName": "Contact",
      "orderDays": "Order days",
      "leadTime": "Lead time (days)",
      "minimumOrder": "Minimum order",
      "currency": "Invoices in",
      "costPriceFactor": "Cost price factor",
      "ourCustomerNumber": "Our customer number",
      "note": "Note",
      "active": "Active"
    },
    "importStatus": {
      "Running": "Running",
      "Completed": "Completed",
      "CompletedWithWarnings": "Completed with warnings",
      "Failed": "Failed"
    },
    "import": {
      "title": "Load a price file",
      "mappingIncomplete": "Fill in the file layout on the right first — at least an item number or a barcode, and either a cost price or stock.",
      "chooseFile": "Choose file",
      "hint": "CSV, TSV or Excel. Cost prices are multiplied by a factor of {factor}.",
      "hintWithCurrency": "CSV, TSV or Excel. Cost prices are multiplied by a factor of {factor} and stored in the workspace's currency.",
      "failed": "The import failed.",
      "runFailed": "The import failed",
      "fileRead": "The file has been read",
      "summary": "{rows} rows · {matched} matched · {prices} cost prices updated",
      "runSummary": "{rows} rows · {matched} matched · {prices} prices",
      "rowsRead": "{count} rows read",
      "rowsCreated": "{count} new",
      "rowsUpdated": "{count} updated",
      "rowsMatched": "{count} matched against the catalogue",
      "pricesChanged": "{count} cost prices changed",
      "rowsSkipped": "{count} skipped",
      "rowsDelisted": "{count} delisted",
      "warnings": "{count} warnings",
      "history": "Earlier imports",
      "noHistory": "No imports yet."
    },
    "mapping": {
      "title": "File layout",
      "saved": "The file layout is saved",
      "fileType": "File type",
      "delimiter": "Delimiter",
      "sheetNumber": "Sheet no.",
      "skipRows": "Skip rows",
      "columnsHint": "Columns are counted from 1 — column A is 1. Empty fields are skipped.",
      "sku": "Item number",
      "ean": "Barcode",
      "name": "Name",
      "extraColumn": "+ column",
      "costPrice": "Cost price",
      "retailPrice": "RRP",
      "stock": "Stock",
      "inStockValue": "\"In stock\" value",
      "inStockPlaceholder": "e.g. Yes",
      "inStockHint": "Only fill in the \"in stock\" value if the stock column holds a word rather than a number.",
      "decimalMark": "Decimal mark",
      "trimCharacters": "Strip characters from cells",
      "trimPlaceholder": "e.g. \"",
      "save": "Save file layout",
      "format": {
        "Delimited": "Text file (CSV, TSV)",
        "Excel": "Excel (.xlsx)"
      },
      "decimal": {
        "Comma": "Comma — 1.234,56",
        "Point": "Full stop — 1,234.56"
      }
    },
    "catalogue": {
      "title": "The supplier's catalogue",
      "unmatchedOnly": "Unmatched only",
      "empty": "No rows yet. Load a price file above.",
      "noMatch": "No match",
      "inStock": "In stock",
      "outOfStock": "Out of stock",
      "unknownStock": "Unknown",
      "delisted": "Delisted",
      "columns": {
        "supplierProduct": "The supplier's product",
        "match": "Match",
        "costPrice": "Cost price",
        "atSupplier": "At the supplier"
      }
    },
    "feeds": {
      "title": "Automatic file fetches",
      "intro": "Fetched automatically every night at 05.15 and run through the same import as a file you upload yourself.",
      "newFeed": "New feed",
      "editFeed": "Edit feed",
      "empty": "No automatic fetches. Files have to be loaded by hand.",
      "loadFailed": "Could not load the feeds.",
      "saved": "The feed is saved",
      "deleteTitle": "Delete feed",
      "deleteBody": "Delete \"{name}\"? Prices already imported are kept.",
      "fetchNow": "Fetch now",
      "importedDetail": "{matched} matched the catalogue · {prices} cost prices changed",
      "unchanged": "The file is unchanged",
      "unchangedDetail": "The supplier has not put up a new file since last time.",
      "fetchFailed": "Could not be fetched",
      "parseFailed": "Could not be read",
      "runFailed": "The run could not be started.",
      "namePlaceholder": "e.g. Price list",
      "urlPlaceholder": "https://prices.example.com",
      "serverPlaceholder": "ftp.example.com",
      "passwordUnchanged": "Unchanged",
      "fileSection": "How the file is built",
      "columnsHint": "Column numbers as in the spreadsheet: column A is 1. Leave blank if the file has no such column.",
      "inStockWord": "Word that means \"in stock\"",
      "inStockHint": "Only if the stock column holds words rather than a number.",
      "fetchNightly": "Fetch automatically every night",
      "mappingIncomplete": "Give at least an item number or a barcode, and either a cost price or stock — otherwise the file cannot be used for anything.",
      "columns": {
        "feed": "Feed",
        "status": "Status",
        "lastFetched": "Last fetched"
      },
      "fields": {
        "name": "Name",
        "transport": "Connection",
        "url": "Address",
        "server": "Server",
        "port": "Port",
        "remotePath": "Path to the file",
        "username": "Username",
        "password": "Password"
      },
      "status": {
        "off": "Switched off",
        "incomplete": "Not configured",
        "neverRun": "Not run yet",
        "ok": "OK",
        "failed": "Failed"
      },
      "errors": {
        "nameRequired": "A name is required.",
        "hostRequired": "Give a server or an address.",
        "remotePathRequired": "Give the path to the file.",
        "portRange": "Port has to be between 0 and 65535."
      },
      "pathPlaceholder": "/export/prices.csv"
    },
    "errors": {
      "notFound": "That supplier does not exist.",
      "mappingUnusable": "The supplier has no file layout. Give at least an item number or a barcode, and either a cost price or stock.",
      "nameRequired": "A name is required.",
      "nameTaken": "A supplier by that name already exists.",
      "leadTimeRange": "Lead time has to be between 0 and 365 days.",
      "weekdayInvalid": "Not a weekday.",
      "hasPurchaseOrders": "The supplier has purchase orders. Deactivate it instead.",
      "hasProducts": "Products are assigned to this supplier. Move them first.",
      "wholesalerNotFound": "That wholesaler does not exist.",
      "wholesalerIsSelf": "A supplier cannot be bought through itself.",
      "wholesalerHasParent": "The chosen wholesaler is itself bought through a wholesaler and so cannot be one.",
      "supplierHasBrands": "This supplier has brands of its own under it and so cannot be placed under a wholesaler.",
      "fileEmpty": "The file is empty.",
      "fileTooLarge": "The file is larger than 32 MB."
    }
  },
  "subscriptions": {
    "title": "Subscriptions",
    "subtitle": "Standing deliveries. Every run becomes an ordinary order in the packing list.",
    "simulatedTitle": "Payments are simulated.",
    "simulatedBody": "The payment provider \"{gateway}\" takes no money — subscription runs create orders, but nothing is charged. Connect a real provider before going live.",
    "failedAttempts": "{count} failed attempts",
    "nextColumn": "Next",
    "customerColumn": "Customer",
    "empty": "No subscriptions.",
    "loadFailed": "Could not load subscriptions.",
    "searchPlaceholder": "Reference, customer or email",
    "tiles": {
      "active": "Active",
      "perMonth": "{amount} per month",
      "overdue": "Overdue",
      "overdueHint": "Should have been charged",
      "dueSoon": "Within 7 days",
      "dueSoonHint": "Going out soon",
      "failedHint": "Needs chasing"
    },
    "payments": {
      "ourRuns": "smibo's runs",
      "atGateway": "At the provider",
      "noRuns": "No runs yet.",
      "amountColumn": "Amount",
      "gatewayNotLive": "The payment provider is not connected yet ({gateway}). No real money has been taken, and there are no transactions to fetch.",
      "gatewayNoHistory": "{gateway} cannot be asked for history from here.",
      "loadFailed": "Could not load payments.",
      "orderLabel": "Order",
      "noAgreement": "There is no payment agreement on this subscription, so there is nothing to fetch.",
      "referenceColumn": "Reference"
    },
    "intervalMonthly": "Every month",
    "intervalEveryNMonths": "Every {count} months",
    "status": {
      "Active": "Active",
      "Paused": "Paused",
      "PaymentFailed": "Payment failed",
      "Cancelled": "Cancelled",
      "PendingPayment": "No payment agreement"
    },
    "runOutcome": {
      "Delivered": "Delivered",
      "PaymentDeclined": "Payment declined",
      "CardExpired": "Card expired",
      "NothingToShip": "Nothing to ship",
      "Error": "Error"
    },
    "anchor": {
      "Rolling": "Rolling",
      "CalendarMonth": "The 1st of the month"
    },
    "anchorHint": {
      "Rolling": "The next delivery is N months after the last one.",
      "CalendarMonth": "Everyone is sent at the same time, whenever they started."
    }
  },
  "confirmSignUp": {
    "title": "Confirm your sign-up",
    "lead": "Confirm that it was you who signed up for {plan}. No money is taken — we will contact you about payment afterwards.",
    "expiredTitle": "This link no longer works",
    "expiredBody": "It is either wrong, already used, or more than seven days old. Fill in the form again and we will send a new link.",
    "doneTitle": "Thank you — you are signed up",
    "doneBody": "Your sign-up is registered under {reference}, and we have sent a confirmation by email.",
    "notActiveYet": "The subscription is not active yet. We will contact you about payment, and the first delivery goes out no earlier than {date}.",
    "manageHere": "You can view and change your subscription here:",
    "deliveredTo": "Delivered to",
    "earliest": "The first delivery goes out no earlier than {date}.",
    "confirmButton": "Yes, that was me — sign me up",
    "notYou": "Did not sign up? Just close the page — nothing more will happen.",
    "failed": "The confirmation could not be completed. Try again shortly."
  },
  "portal": {
    "loadFailed": "The page could not be loaded right now. Try again shortly.",
    "actionFailed": "That did not work.",
    "expiredTitle": "This link no longer works",
    "expiredBody": "The subscription may have been cancelled, or the link may have been replaced by a newer one. Get in touch and we will sort it out.",
    "paymentFailedBody": "We could not take the payment. Get in touch and we will send a link to renew the card.",
    "nextDelivery": "Next delivery",
    "cardExpires": "Card expires",
    "skipNext": "Skip the next delivery",
    "skipped": "The next delivery has been skipped.",
    "pause": "Pause",
    "paused": "Your subscription has been paused.",
    "contactUs": "Want to change what is in the box, or how often it comes? Get in touch and we will sort it out.",
    "street2": "Floor, door etc.",
    "cancelReason": "May we ask why? (optional)",
    "title": "Your subscription",
    "addressSaveFailed": "The address could not be saved.",
    "cancelled": "Your subscription has been cancelled. You will not receive any more deliveries.",
    "resumed": "Your subscription has been resumed.",
    "cancelTitle": "Cancel subscription",
    "cancelBody": "You will not receive any more deliveries, and no more payments will be taken. You can always start a new one.",
    "intervalMonthly": "Every month",
    "intervalQuarterly": "Every quarter",
    "intervalYearly": "Once a year",
    "intervalEveryNMonths": "Every {count} months",
    "status": {
      "Active": "Active",
      "Paused": "Paused",
      "PaymentFailed": "Payment failed",
      "Cancelled": "Cancelled",
      "PendingPayment": "Awaiting activation"
    },
    "resume": "Resume",
    "editAddress": "Change address",
    "cancel": "Cancel",
    "editAddressTitle": "Change the delivery address",
    "keepIt": "Keep the subscription"
  },
  "plans": {
    "title": "Subscriptions for sale",
    "subtitle": "What customers can sign up for themselves. Every published subscription has a link you can put on your website.",
    "newPlan": "New subscription",
    "editPlan": "Edit subscription",
    "empty": "No subscriptions yet. Create one to start taking sign-ups.",
    "loadFailed": "Could not load the subscriptions.",
    "saved": "Subscription saved",
    "linkCopied": "Link copied",
    "copyFailed": "Could not copy",
    "planColumn": "Subscription",
    "signUpsColumn": "Sign-ups",
    "linkColumn": "Link",
    "published": "Published",
    "draft": "Draft",
    "notPublished": "Not published",
    "needsPublicUrl": "Set Smibo:PublicUrl to get a link",
    "copyLink": "Copy link",
    "lineCount": "{count} lines",
    "name": "Name",
    "description": "Description",
    "descriptionHint": "shown on the sign-up page",
    "everyNMonths": "Every … months",
    "shipping": "Delivery charge",
    "deliveryMethod": "Delivery method",
    "leadTime": "First delivery in",
    "days": "days",
    "contents": "Contents",
    "noProducts": "No products chosen yet.",
    "addProduct": "Add product",
    "productSearch": "Search by SKU or name",
    "noPrice": "no price",
    "publishedHint": "Published — the link works and customers can sign up",
    "anchorRolling": "N months after the last delivery",
    "anchorCalendar": "The 1st of the month — everyone sent together",
    "pricePlaceholder": "The product price"
  },
  "subscriptionDetail": {
    "linkCopiedHint": "Paste it into an email to the customer.",
    "linkFailed": "Could not fetch the link",
    "loadFailed": "Could not load the subscription.",
    "paused": "Paused",
    "skipped": "Next delivery skipped",
    "runNowTitle": "Run the charge now",
    "runNowBody": "The subscription is charged and an order created straight away, without waiting for the nightly job.",
    "runNow": "Run now",
    "ranNow": "The charge has run",
    "cancelTitle": "Cancel subscription",
    "cancelBody": "The payment agreement is cancelled with the provider, and nothing more is sent.",
    "cancelConfirm": "Cancel the subscription",
    "copyCustomerLink": "Copy customer link",
    "failedTimes": "The payment failed {count} times.",
    "parkedBody": "The subscription is parked — it has not been cancelled, so the customer can carry on with a new card.",
    "newAgreement": "Record a new payment agreement",
    "cardExpiredBody": "The card expired {expiry}. The next charge will fail.",
    "updateCard": "Update card",
    "freeStock": "{count} free in stock",
    "unknownProduct": "This product is no longer in the catalogue — the charge will fail.",
    "units": "{count} units",
    "interval": "Interval",
    "rhythm": "Rhythm",
    "started": "Started",
    "editAgreement": "Edit payment agreement",
    "editTitle": "Edit subscription",
    "intervalMonths": "Interval (months)",
    "zeroRemoves": "Set to 0 to remove the product from the subscription.",
    "agreementHelp": "Record the agreement the payment provider issued for the customer's card. A parked subscription becomes active again immediately.",
    "expiryMonth": "Expiry month",
    "expiryYear": "Expiry year",
    "back": "Back to subscriptions",
    "skip": "Skip",
    "agreementTitle": "Payment agreement"
  },
  "translations": {
    "title": "Your own wording",
    "intro": "Write your own wording for individual phrases. Everything you do not change keeps up with releases.",
    "key": "Key",
    "value": "Your wording",
    "default": "Default",
    "changedSince": "The default has changed since you wrote your own.",
    "saved": "Wording saved",
    "removed": "Your wording has been removed",
    "empty": "You are using the default wording everywhere.",
    "errors": {
      "localeUnsupported": "That language is not supported.",
      "valueRequired": "Enter some wording."
    },
    "loadFailed": "Could not load your wording.",
    "searchPlaceholder": "Search a key or a phrase",
    "onlyMine": "Only what you have changed",
    "changedCount": "{count} changed",
    "noMatches": "No phrases match that search.",
    "editTitle": "Write your own wording",
    "reset": "Reset",
    "resetTitle": "Back to the default",
    "resetBody": "Your own wording is deleted, and the phrase follows the releases again.",
    "removeFailed": "Could not remove your wording",
    "placeholderHint": "Curly braces like {'{'}name{'}'} are values the phrase is given. Drop one and the finished sentence is missing that number or name."
  },
  "auth": {
    "errors": {
      "linkNoLongerValid": "This link no longer works. Ask for a new one.",
      "resetFailed": "The password could not be changed.",
      "passwordTooShort": "The password must be at least {length} characters.",
      "passwordRequiresDigit": "The password must contain at least one digit.",
      "passwordRequiresLower": "The password must contain at least one lowercase letter.",
      "passwordRequiresUpper": "The password must contain at least one uppercase letter.",
      "passwordRequiresSymbol": "The password must contain at least one character that is neither a letter nor a digit.",
      "passwordRequiresUniqueChars": "The password must contain at least {count} different characters.",
      "emailNotConfirmed": "Confirm your email address before signing in.",
      "codeInvalid": "That code does not match, or it is too old. Ask for a new one.",
      "codeNotSent": "The code could not be sent. Try asking for a new one.",
      "twoFactorExpired": "The sign-in attempt has expired. Start again.",
      "confirmBeforeTwoFactor": "Confirm your email address before turning the code on — it has to be sent somewhere."
    }
  },
  "forgotPassword": {
    "title": "Forgotten password",
    "subtitle": "We will mail you a link to choose a new one with.",
    "submit": "Send the link",
    "sentTitle": "On its way",
    "sentBody": "If there is an account for {email}, the link will be in the inbox shortly. Check the spam folder too.",
    "backToLogin": "Back to sign-in"
  },
  "resetPassword": {
    "title": "Choose a new password",
    "subtitle": "The old one stops working the moment you save.",
    "newPassword": "New password",
    "repeatPassword": "Repeat the password",
    "mismatch": "The two passwords are not the same.",
    "submit": "Save the password",
    "doneTitle": "Password changed",
    "doneBody": "You have been signed out everywhere. Sign in with the new one.",
    "signIn": "Sign in"
  },
  "confirmEmail": {
    "title": "Confirm your email address",
    "lead": "Press the button to confirm that this address is yours.",
    "confirmButton": "Confirm the address",
    "doneTitle": "Thank you — the address is confirmed",
    "doneBody": "You can sign in as usual.",
    "signIn": "Sign in"
  },
  "carriers": {
    "title": "Carrier accounts",
    "subtitle": "The account labels are booked on. Nothing here books a parcel.",
    "add": "Connect an account",
    "addTitle": "Connect a carrier account",
    "editTitle": "Edit carrier account",
    "empty": "No carrier accounts yet.",
    "loadFailed": "Could not load the carrier accounts.",
    "saveFailed": "Could not save the carrier account.",
    "testFailed": "The connection could not be tested.",
    "test": "Test",
    "testModeOn": "Test mode",
    "notConfigured": "Not set up",
    "productsFound": "Products this account can ship with:",
    "name": "Name",
    "key": "Key",
    "keyHint": "Derived automatically. This is the value a shipping rule puts in its Carrier field.",
    "apiUser": "API user",
    "apiKey": "API key",
    "secretHint": "Fill in only to replace. Left blank, the stored one is kept.",
    "baseUrl": "API address",
    "baseUrlHint": "Blank means production. The sandbox is on a different domain.",
    "senderCompany": "Sender",
    "senderHint": "The address parcels are sent from. It is printed on the label.",
    "senderStreet": "Street and number",
    "senderPostalCode": "Postcode",
    "senderCity": "Town",
    "senderCountry": "Country",
    "useOwnAgreement": "Book on our own carrier agreement",
    "testMode": "Test mode — no real parcels are booked",
    "testModeOffWarning": "With test mode off, the next dispatch is a real parcel on a real invoice.",
    "advanced": "Advanced"
  },
  "invitation": {
    "title": "Choose your password",
    "subtitle": "Then you are ready to sign in.",
    "choosePassword": "Password",
    "submit": "Save and continue",
    "doneTitle": "You are all set",
    "doneBody": "Your password is set and your email address is confirmed. Sign in to get started."
  },
  "twoFactor": {
    "title": "Check your email",
    "sentTo": "We have sent a code to {email}.",
    "code": "Code",
    "submit": "Continue",
    "resend": "Send a new code",
    "resent": "Sent. Check your inbox — and your spam folder.",
    "rememberBrowser": "Do not ask again on this computer",
    "back": "Back to sign-in"
  },
  "productImages": {
    "title": "Fetching the pictures home",
    "subtitle": "The product pictures still point at the old shop's servers. They work until that shop is switched off — so they are fetched home, and smibo owns the catalogue rather than borrowing it.",
    "counts": "{stored} of {total} fetched · {remaining} to go",
    "failed": "{count} could not be fetched",
    "fetch": "Fetch the pictures",
    "stop": "Stop",
    "includeDead": "Include the {count} pictures on products with no stock, no activity and no sales",
    "retryFailed": "Try the failed ones again",
    "allHeld": "Every picture is held here now."
  }
}
